$(function() {
    var siteHeader = document.getElementById("site_head_wrap");
    var search = document.getElementById("search_home");
    var shade = document.getElementById("shad_menu");

    function onWinScroll() {
        if (!document.body.classList.contains("in_tunnel")) {
            var scrollTop = $(document).scrollTop();

            if (siteHeader.classList.contains("sticky")) {
                if (scrollTop === 0) {
                    siteHeader.classList.remove("sticky");

                    // Add / remove sticky to algolia search container
                    if (document.querySelector('.ais-InstantSearch')) {
                        if (document.querySelector('.ais-InstantSearch').classList.contains("sticky")) {
                            document.querySelector('.ais-InstantSearch').classList.remove("sticky");
                        }
                    }
                    shade.classList.remove("sticky");
                }
            } else {
                    if (scrollTop > ($('#site_head_wrap').outerHeight() - 100)) {
                    siteHeader.classList.add("sticky");

                    // Add / remove sticky to algolia search container
                    if (document.querySelector('.ais-InstantSearch')) {
                        if (!document.querySelector('.ais-InstantSearch').classList.contains("sticky")) {
                            document.querySelector('.ais-InstantSearch').classList.add("sticky");
                        }
                    }
                    shade.classList.add("sticky");
                }
            }
        }
    }

    function onSearchStateChange(evt) {
        if (evt.type === "focus") {
            search.parentElement.classList.add("searching");
        } else if (search.value.trim() === "") {
            search.parentElement.classList.remove("searching");
        }
    }
    $(search).on({focus: onSearchStateChange, blur: onSearchStateChange});

    $(window).on("scroll", onWinScroll);

    onWinScroll();

    $(document).on("click", ".button", btnLoaderTrigger);

    $(document).on("focus", "#clientTel", formCoFieldTelFix);
    $(document).on("focusout", "#clientTel", formCoFieldTelFixOut);

    /* Filter rayon */

    $(document).on("click", ".filter_checkbox_hide", function() {
        var currentClass = $(this).attr("class");
        $(".filter_checkbox_hide").each(function (index) {
            if (currentClass != $(this).attr("class")) {
                $(this).prop('checked', false);
            }
        });
    });

    //prefooter block collapse class based css animated
    $('.block_links_prefooter .collapse').on("click", function () {
        var prefooter = $('.block_links_prefooter .collapse');

        if (prefooter.hasClass('hidden')){
            prefooter.removeClass('hidden');
        } else {
            prefooter.addClass('hidden');
        }
    });

    /* Smooth animation for all anchor */

    var $root = $('html, body');

    $('a[href^="#"]').click(function () {
        if ($(this).attr("href").length > 1) {
            var scrollPos = $( $.attr(this, 'href') ).offset().top;
            scrollPos = scrollPos - 120;
            $root.animate({
                scrollTop: scrollPos
            }, 500);

            return false;
        }
    });

    $('.shipment_cgv_link').click(function () {
        $(this).toggleClass('change').attr('data-content','bar');
    });

    $('#form_contact1 .w-submit-button').click(function () {
        var lastName = $('input[name="contactPrenom"]').val();
        var name = $('input[name="contactNom"]').val();
        var fullName = lastName + '&nbsp;' + name;
        setTimeout(function () {
            if ($('#ligthbox_send_store_information #form_contact1:visible').length && $('#ligthbox_send_store_information #form_contact1 .w-input-error:visible').length === 0) {
                $("#ligthbox_send_store_information #contact_store").css("display", "none");
                $("#ligthbox_send_store_information #contact_store").after(Translator.translate('mail_wording_sent', fullName));
            } else if ($('.choose_fav_mag.showForm:visible').length && $('.choose_fav_mag.showForm .w-input-error:visible').length === 0) {
                $(".choose_fav_mag.showForm #contact_store").css("display", "none");
                $(".choose_fav_mag.showForm #contact_store" ).after(Translator.translate('mail_wording_sent', fullName));
            }
        }, 1200);
    });

    $(document).on('click', '#internal-links-button', function (e) {
        e.preventDefault();
        var wrapper = $(this).closest('.internal-link-wrapper');
        var links   = wrapper.find('.internal-links');

        if (links.is(':visible')) {
            links.stop(true, true).slideUp(200, function () {
            wrapper.removeClass('opened');
            });
        } else {
            links
            .css('display', 'flex')
            .hide()
            .stop(true, true)
            .slideDown(200, function () {
                wrapper.addClass('opened');
            });
        }
    });

    if ($('.w-contact-form').length) {

        var placeholderTxt = $('.placeholderTxt');
        var inputFields = $('.w-contact-form input');

        if (placeholderTxt.hasClass('inUse')) {
            $(this).prev(inputFields).focus();
        }

        placeholderTxt.on('click touch', function () {

            $(this).addClass('inUse');
            $(this).prev(inputFields).focus();

            if ($(this).prev().children(inputFields).hasClass('clientPhone')) {

                $('.clientPhone').focus();
            }
        });

        inputFields.on('focus', function () {

            $(this).addClass('inUse');
            $(this).next(placeholderTxt).addClass('inUse');

            if ($(this).hasClass('clientPhone')) {

                $(this).parent().next(placeholderTxt).addClass('inUse');
            }
        });

        inputFields.on('blur', function () {

            if ($(this).val() === '') {

                $(this).removeClass('inUse');
                $(this).next(placeholderTxt).removeClass('inUse');

                if ($(this).hasClass('clientPhone')) {

                    $(this).parent().next(placeholderTxt).removeClass('inUse');
                }
            }
        });
    }
    if ($(".menu_push_replacement_container").length) {
        $(".menu_push_replacement_container").each(function() {
            if ($(this).find(".swiper-wrapper .swiper-slide").length <= 1) {
                $(this).addClass('no_swiper');
                return;
            }

            var idReplacement = $(this).attr("id");

            if ($('#' + idReplacement + '.swiper-initialized').length) {
                return;
            }

            new Swiper('#' + idReplacement, {
                slidesPerView: 1,
                spaceBetween: 0,
                roundLengths: true,
                pagination: {
                    el: '#' + idReplacement + ' .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '#' + idReplacement + ' .swiper-button-next',
                    prevEl: '#' + idReplacement + ' .swiper-button-prev',
                },
            });
        });
    }


    function adjustJoinWidget(host) {
        if (host.shadowRoot.querySelector('[data-join-style]')) return;

        var style = document.createElement('style');
        style.setAttribute('data-join-style', '');
        style.textContent = '* { --join-sticky-right: 5% !important; }';
        host.shadowRoot.appendChild(style);
    }

    // Si le widget est chargé dynamiquement après le DOM
    var joinObserver = new MutationObserver(function () {
        var host = document.querySelector('.join-sticky-host');
        if (!host) return;

        if (host.shadowRoot) {
            adjustJoinWidget(host);
            joinObserver.disconnect();
        }
    });

    joinObserver.observe(document.body, { childList: true, subtree: true });

    // SW-21340: cache initial widget markup for AJAX colour swap fallback.
    var initialJoinWidget = document.querySelector('.join-widget-target-component');
    if (initialJoinWidget) {
        window.__joinWidgetHtml = initialJoinWidget.outerHTML;
    }
});

// SW-21340: refresh JOIN Stories widget on colour swap; SDK bootstrap runs once at page load.
function refreshJoinStoriesWidget(newRef) {
    var html = window.__joinWidgetHtml;
    if (!html || !newRef) return;

    var el = document.querySelector('.join-widget-target-component');
    if (el && el.getAttribute('data-join-product-id') === newRef && el.classList.contains('is-loaded')) return;

    if (window.__joinRefreshCancel) window.__joinRefreshCancel();
    var cancelled = false;
    window.__joinRefreshCancel = function () { cancelled = true; };

    if (!el) {
        var $widget = $(html).attr('data-join-product-id', newRef).removeClass('is-loaded');
        $widget.insertAfter($('.product_main_wrapper form.product_info', '#site_global_wrap').first());
        el = $widget.get(0);
    } else {
        el.setAttribute('data-join-product-id', newRef);
        el.classList.remove('is-loaded');
        el.innerHTML = '';
    }

    if (typeof window.loadJoinStoriesWidget !== 'function') return;
    window.loadJoinStoriesWidget(el);

    // SDK doesn't re-toggle .is-loaded on re-init; poll shadowRoot/children then reveal or hide.
    var start = performance.now();
    (function reveal() {
        if (cancelled || !el.isConnected) return;
        if (el.shadowRoot || el.childElementCount > 0) {
            el.classList.add('is-loaded');
            return;
        }
        if (performance.now() - start > 2500) {
            el.remove();
            return;
        }
        requestAnimationFrame(reveal);
    })();
}

window.addEventListener('processDisplayProductInList', function (event) {
    const { jqueryObject, result } = event.detail;
    processDisplayProductInListJJA($(jqueryObject), result);
});

document.onload=function(){

    if ($("#slider-range").length) {
        var prix_min = $("#amount1").val();
        var prix_max = $("#amount2").val();
        $("#amount1").val(prix_min);
        $("#amount2").val(prix_max);
        $("#slider-range").slider("option", {
            min: parseInt(prix_min),
            max: parseInt(prix_max),
            values: [parseInt(prix_min), parseInt(prix_max)],
    });

        $(".ui-slider-range").width("100%");
        $(".ui-slider-range").css("left", "0%");
        $(".ui-slider-range")
            .next()
            .css("left", "0%");
        $(".ui-slider-range")
            .next()
            .next()
            .css("left", "100%");
    }
}

function formCoFieldTelFix() {
    $( "#clientTel" ).parent().children("p.w-input-label").css("transform", "translateY(-115%)");
    $( "#clientTel" ).parent().children("p.w-input-label").css("font-size", ".75rem");
    $( "#clientTel" ).parent().children("p.w-input-label").css("transition", "transform .2s ease-out,font-size .2s ease-out,opacity .2s linear");
}

function formCoFieldTelFixOut() {
    if ($('#clientTel').val() == '') {
        $( "#clientTel" ).parent().children("p.w-input-label").css("transform", "translateY(-50%)");
        $( "#clientTel" ).parent().children("p.w-input-label").css("font-size", "13px");
    }
}

var rex_php_tags = new RegExp("<\\?php(?:[\\n\\r]|.)+?\\?>(?!\"|'')", "gim");
var rex_script_tags = new RegExp("<script(?:[\\n\\r]|.)+?\\/script>", "gim");
var rex_comments_tags = new RegExp("<!--(?:[\\n\\r]|.)+?-->", "gim");

// Strips php contents /!\ THIS DELETES PHP TAGS AND EVERYTHING IN BETWEEN /!\
function stripPhpContents(str) {
    return str.replace(rex_php_tags, "");
}

// Strips js contents /!\ THIS DELETES SCRIPT TAGS AND EVERYTHING IN BETWEEN /!\
function stripJSContents(str) {
    return str.replace(rex_script_tags, "");
}

// Strips html comments /!\ THIS DELETES COMMENTS TAGS AND EVERYTHING IN BETWEEN /!\
function stripHTMLComments(str) {
    return str.replace(rex_comments_tags, "");
}

function stripCombo(str) {
    var output = stripHTMLComments(str);

    output = stripJSContents(output);
    output = stripPhpContents(output);

    return output;
}

/**
 * Buttons loader management
 */
function btnLoaderTrigger(evt) {
	"use strict";

	var element = $(this);
	var loader = $(this).next(".loader");

	if (loader.length > 0) {

		evt.preventDefault();

		loader.removeAttr("style").parent().addClass("loading");
		loader.removeClass("cache");
		loader.addClass("loading");

		setTimeout(function () {
			loader.parent().removeClass("loading");
			loader.addClass("cache");
			loader.removeClass("loading");
		}, 1200);

		if ($(this).attr("href")) {
			window.location.assign($(this).attr("href"));
		}
	}
}

function openMultiShad(id) {
    var isSavoirPlus = id === 'popup_savoir_plus';
    var hasPdvOpen = $('#pdvBox').hasClass('actif');
    var hasStockAlertOpen = $('#lightbox_stock_alert').hasClass('actif');

    if ($('.lightbox.actif').length) {
        if (isSavoirPlus && (hasPdvOpen || hasStockAlertOpen)) {
            $('.lightbox.actif').not('#pdvBox, #lightbox_stock_alert').removeClass('actif');
        } else {
            $('.lightbox.actif').removeClass('actif');
        }
    }

    if ($('.alreadyInWishlistTxt').length) {
        $('.alreadyInWishlistTxt').addClass('cache');
    }

    $("#" + id).addClass('actif');

    if (id !== 'zoomBox') {
        if (!$("#shad").hasClass('actif')) {
            $("#shad").addClass('actif');
        }
        $("#shad").off('click.multiShad').on('click.multiShad', function () {
            closeMultiShad(id);
        });
    }

    if (id == "lightbox_achat_express") {
        var prod_id,
        form,
        prod_qty,
        prod_rr_id,
        prod_is_wish;

        prod_id = $('#lightbox_achat_express #produit_id').val();
    }

    if (id === 'lightboxOrderGiftCard' || id === 'sendwishlistbox') {
        $('#shad').addClass('actif');
    }

    if (id === 'selection-offer') {
        $('.selection-offer-content').overlayScrollbars({});
    }

    if (id === 'mention_legales_pop_up' || id === 'popup_savoir_plus' || id === 'lightbox_stock_alert' || id === 'modboxpromo') {
        $("#shad").addClass('below_header');
    }
}

function closeMultiShad(id) {
    var keepPdvOpen = id === 'popup_savoir_plus' && $('#pdvBox').hasClass('actif');
    var isStockAlertOpen = $('#lightbox_stock_alert').hasClass('actif');
    if (id === 'popup_savoir_plus' && isStockAlertOpen) {
        $('#' + id).removeClass('actif');
        $('#shad').off('click.multiShad').on('click.multiShad', function () {
            closeMultiShad('lightbox_stock_alert');
        });
        return;
    }

    // Restore body styles only when the zoomBox is being closed
    if (id === 'zoomBox' || (id === undefined && $('#zoomBox').hasClass('actif'))) {
        $('body.product_page').css({
            'position': '',
            'width': '',
            'padding-right': ''
        });
    }

    $("#" + id).removeClass('actif');
    if (keepPdvOpen) {
        $('#shad').addClass('actif').off('click.multiShad').on('click.multiShad', function () {
            closeMultiShad('pdvBox');
        });
    } else {
        $("#shad").off('click.multiShad').removeClass('actif').removeClass('below_header');
        $(".shad").removeClass('actif').removeClass('white');
    }

    if (id === 'zoomBox' || (id === undefined && !$('#zoomBox').hasClass('actif'))) {
        var jqzoomEl = document.querySelector('#jqzoom');
        if (jqzoomEl && jqzoomEl.swiper && typeof jqzoomEl.swiper.enable === 'function') {
            jqzoomEl.swiper.enable();
        }
        var visualScrollerEl = document.querySelector('#visual_scroller');
        if (visualScrollerEl && visualScrollerEl.swiper && typeof visualScrollerEl.swiper.enable === 'function') {
            visualScrollerEl.swiper.enable();
        }
    }

    if ($('.alreadyInWishlistTxt').length) {
        $('.alreadyInWishlistTxt').addClass('cache');
    }

    if (id === 'exit_overlay_OVI') {
        $('#exit_overlay_OVI').hide();
        $("#shad").hide();
    }

    if (id === 'mention_legales_pop_up' || id === 'popup_savoir_plus' || id === 'lightbox_stock_alert') {
        if(!keepPdvOpen) {
            $('#shad').removeClass('below_header');
        }
    }
}

function changeLocale(locale, uri, site) {
	$.ajax({
		url: path_relative_root + create_link('ajax_get_uri_by_lang'),
		type: 'post',
		data: {
			lang: locale,
			url: uri,
			site : site
		},
		success: function (data) {
			if (data != "") {
				var force = "";
				if (uri == "/") {
					force = "?force";
				}
				location.href = data + force;
			}
		}
	});
}

var elmt;
var loader;
var prev_display;
// Shows button's underlying loader and triggers defined action
function waitingProcess(loader, action, id_form) {
    var elmt = $(this),
        loader = $(loader);

    prev_display = elmt.css("display");

    if (!loader.parent().hasClass("loading")) {
        loader.parent().addClass("loading");

        switch (action) {
            case 0:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabAuthTop,
                    1,
                    path_relative_root
                );
                break;

            case 1:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabLostPwdTop,
                    1,
                    path_relative_root
                );
                break;

            case 2:
                window.setTimeout(ajaxDeconnect, 1000, path_relative_root);
                break;

            case 3:
                window.setTimeout(function() {
                    checkAllForm(tabError, 0, path_relative_root, id_form);
                    loader.parent().removeClass("loading");
                }, 1000); // attention ne pas modifier le temps 1000 pour que le intelinput ai le temps de bien remplir les données
                break;

            case 4:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabAuth,
                    1,
                    path_relative_root
                );
                break;

            case 5:
                window.setTimeout(
                    ajax_checkAllForm,
                    1000,
                    tabLostPwd,
                    1,
                    path_relative_root
                );
                break;

            case 6:
                window.setTimeout(checkFormParrainage, 1000);
                break;

            case 7:
                if (
                    checkAllForm(
                        tabErrorGrattez,
                        0,
                        path_relative_root,
                        id_form
                    )
                ) {
                    window.setTimeout(processGrattezGagnez(), 1000);
                }
                break;
        }
    }
}

function hideLoader() {
    if (loader) {
        loader.css("display", "none");
        loader
            .removeAttr("style")
            .parent()
            .removeClass("loading");
    }
    if (elmt) {
        elmt.css("display", prev_display);
    }
}

function revealAlmaWidget() {
    var el = document.getElementById('alma-widget');
    if (!el) return;
    el.classList.remove('alma-loaded');

    var debounce;
    var observer = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
            if (el.textContent.trim().length > 0) {
                el.classList.add('alma-loaded');
                observer.disconnect();
            }
        }, 200);
    });

    observer.observe(el, { childList: true, subtree: true });

    setTimeout(function () { observer.disconnect(); }, 8000);
}

$(function () {
    revealAlmaWidget();
});

// Reload product from ref
/**
 * loadProduct function
 * @param new_id
 * @param type
 * @param page
 * @param itm_rr_id
 * @param has_stock
 * @param dateArrivageJJA
 * @param triggerType : new param to determine from where is triggered the loadProduct function (colorChange, sizeChange, null(-> FP))
 * @param is_regroup
 */

function loadProduct(new_id, type, page, itm_rr_id, triggerType, is_regroup = true) {
    var form = this;
    var old_id = this.getValue('produit_id');
    var cpt = this.getValue('cpt');
    var col_id = this.getValue(this.getValue('idCouleur'));
    var sze_id = this.getValue(this.getValue('idTaille'));
    var act = this.getValue('act');
    var qte_itm = 0;
    triggerType = (triggerType !== undefined) ? triggerType : '';

    //Get original width and height of changed item, preserving style
    var oldModel = $(this).attr('id') !== '' ? $(this).attr('id').replace('prod_info_', '#itm-') : '',
        newModel = oldModel !== '' ? oldModel.replace('_', '-') : '',
        newWidth = $(newModel).css('width');

    if (this.elements.namedItem('qteProd')  ) {
        qte_itm = this.elements.namedItem('qteProd').value;
    }

    var is_model = this.getValue('hdn_is_model');
    var is_wishlist = $('#wishlist').length > 0;
    var is_achat_express = $('#is_achat_express_v2').val() == 1;

    var cpt_prod = itm_rr_id !== '' ? itm_rr_id.replace('_', '') : '';
    var data = {
        produit_id : old_id,
        produit_principal : old_id,
        couleurProd : col_id,
        tailleProd : sze_id,
        act : act,
        qteProd : qte_itm,
        hdn_product_id : old_id,
        hdn_is_model : is_model,
        produit_id_new : new_id,
        type : type,
        type_page : (page !== undefined && page !== '' ) ? page : 'product',
        is_achat_express : is_wishlist ? 1 : 0,
        is_achat_express_v2 : is_achat_express && !is_wishlist ? 1 : 0,
        cpt_prod : cpt_prod-1
    };

    if (is_wishlist) {
        data.wishlist = true;
    }

    $.ajax({
        type : 'post',
        url : path_relative_root + 'ajax_get_product_regroup_ref.php',
        data : data,
        beforeSend : function () {

        },
        success : function (res) {
            try {

                res = $.parseJSON(res);
            } catch (e) {

                console.error('parseJSON');
                return;
            }

            if (res.success == 'ok') {
                var datas = res.datas;

                if (data.type_page == 'product') {

                    var $html_main = $(stripCombo(datas.html_main));

                    var prod_assoc = $('#assocs_slider', $html_main);
                    var color = $("#ligne_couleur").html();

                    var main_wrapper = $('.product_main_wrapper', $html_main);
                    var info_wrapper = $('.product_info_wrapper', $html_main);
                    var zoom_box_wrapper = $('#zoom_box_wrapper', $html_main);
                    var zoom_thumb_wrapper = $('.zoom_main_wrapper .thumb_wrapper', $html_main);

                    // CROSS-SELLS
                    var associated_products = $('#associated_products', $html_main);
                    var similar_products = $('#similar_products', $html_main);
                    var customers_also_bought = $('#customers_also_bought', $html_main);
                    var same_category = $('#same_category', $html_main);

                    if (data.is_achat_express_v2) {
                        if (is_regroup) {
                            // Photo et information
                            var itm_id = old_id + (itm_rr_id !== '' ? itm_rr_id.replace('_', '-') : '');
                            $('#itm-' + itm_id).replaceWith($html_main);

                            var new_itm_id = new_id + (itm_rr_id !== '' ? itm_rr_id.replace('_', '-') : '');

                            var margin_right = $('#itm-' + new_itm_id).next().css('margin-right');
                            $('input.color_' + new_id + itm_rr_id).prop('checked', false);

                            $('input#color_' + new_id + '_' + data.couleurProd + itm_rr_id).prop('checked', true);

                            initAchatExpressSwipers();
                        }
                        getWishlistProducts();

                        // 5FIVE SPECIAL CASE INTEGRATION : Once you have selected a color, in achat_express_v2 --> Display sizes
                        if (triggerType === 'colorChange') {
                            // Hide colors if visible
                            if ($("#ligne_couleur_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).is(':visible')) {
                                $("#ligne_couleur_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).fadeOut(600);
                            }
                            // Display sizes right after
                            setTimeout(function() {
                                $("#ligne_pointure_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).fadeIn(600);
                            }, 600)
                        } else if (triggerType === 'sizeChange') {
                            // On size change -> be sure the product is available
                            $('#tailleProd_' + (new_id + itm_rr_id)).val(sze_id);

                            // En fonction de la couleur on regarde si le produit est disponible -> si getAvailableQuantity renvoi true, on ajoute au panier
                            if (getAvailableQuantity(new_id, qte_itm, 'product', data.couleurProd, itm_rr_id)) {
                                waitingAddToBasket(null,  document.getElementById('prod_info_' + new_id + itm_rr_id), '', itm_rr_id);
                            } else {
                                // If getAvailableQuantity renvoi false == no stock, on affiche l'alerte stock;
                                if ($("#ligne_pointure_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).is(':visible')) {
                                    $("#ligne_couleur_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).is(':visible').fadeOut(600);
                                }

                                // If no stock, show alert stock and hide add to basket btn
                                $("#bloc_add_color_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).hide();
                                $("#bloc_add_alert_" + (new_id + (itm_rr_id !== '' ? itm_rr_id : ''))).show();
                            }
                        }
                    } else if (is_wishlist) {
                        // Photo et information
                        $('.product_main_wrapper', '#lightbox_achat_express').html(main_wrapper.html());
                        // Description compo, livraison, guide tailles
                        $('.product_feats_wrapper', '#lightbox_achat_express').html(feats_wrapper.html());
                    } else {
                        var $html_middle = $(stripCombo(datas.html_middle));

                        $('.item_price_wrapper', $html_main).next('div').after($html_middle).remove();

                        var contents = $('<div />').html($html_main);

                        var video = $('.wrapper_video', contents);
                        $('.product_main_wrapper', '#site_global_wrap').html(main_wrapper.html());
                        $('.product_main_wrapper', '.product_info_wrapper').html(main_wrapper.html());

                        // CROSS-SELLS
                        $('.product_main_wrapper', '#associated_products').html(associated_products.html());
                        $('.product_main_wrapper', '#similar_products').html(similar_products.html());
                        $('.product_main_wrapper', '#customers_also_bought').html(customers_also_bought.html());
                        $('.product_main_wrapper', '#same_category').html(same_category.html());

                        if (prod_assoc.length > 0) {
                            $('#assocs_slider', '#site_global_wrap').after(prod_assoc).remove();
                        }

                        // depending on triggerType, update either color checked or size selected
                        if (triggerType == 'sizeChange') {
                            $('#tailleProd .size').prop('selected', false);
                            $('#tailleProd option#size_'+data.tailleProd).prop('selected', true);
                        }

                        if (triggerType == 'colorChange') {
                            $('input.color').prop('checked', false);
                            $('input#color_'+data.couleurProd).prop('checked', true);
                        }

                        $('#videoBox', '#site_global_wrap').remove();
                        $('#shade').after(video);
                        if (document.getElementById("alma-widget") !== null) {
                            initAlmaWidget();
                            revealAlmaWidget();
                        }

                        $('.breadcrumb.current').html('<span>' + datas.product.titreobjet + '</span>');

                        //zoom box
                        $('#zoom_box_wrapper').html(zoom_box_wrapper.html());
                        $('.zoom_main_wrapper .thumb_wrapper').html(zoom_thumb_wrapper.html());

                        getAvailableQuantity.call($('form.product_info', '#site_global_wrap').get(0), data.produit_id_new, data.qteProd,'', data.couleurProd, itm_rr_id);

                        // Reinitialize product_tabs after HTML replacement
                        // Double requestAnimationFrame ensures DOM is fully stabilized before initialization
                        requestAnimationFrame(function() {
                            requestAnimationFrame(function() {
                                if (typeof window.reinitProductTabs === 'function') {
                                    window.reinitProductTabs();
                                }
                            });
                        });

                        // SW-21340: refresh JOIN Stories widget on colour swap.
                        refreshJoinStoriesWidget(datas.product && datas.product.ref);
                    }

                } else if (data.type_page == 'assoc') {
                    if (data.is_achat_express_v2) {
                        // Photo et information
                        var $html_main = $(stripCombo(datas.html_main));
                        var itm_id = old_id + (itm_rr_id !== '' ? itm_rr_id.replace('_','-') : '');

                        $('#itm-' + itm_id).replaceWith($html_main);
                        $('input.color_' + new_id + itm_rr_id).prop('checked', false);
                        $('input#color_' + new_id + '_' + data.couleurProd + itm_rr_id).prop('checked', true);
                    }
                }

                if (typeof $('#' + old_id + '-' + cpt) !== "undefined") {
                    $('#' + old_id + '-' + cpt).attr("id", datas.product.id + "-" + cpt);
                }

                checkProductInWishlist(datas.product.id, itm_rr_id);

                if (wShop.$refs.wAlertestockForm) {
                    wShop.$refs.wAlertestockForm.reloadBloc += 1;
                }

                $('.thumbslide .see_more').on('click', function(e) {
                    $('.thumbslide').removeClass('active');
                    $(this).parents('.thumbslide').addClass('active');
                });

            }else{
                $( '#btn_error' ).fadeIn();
            }
        },
        complete : function () {
            var heads = $("[data-tab-head]");
            var containers = $("[data-tab-container]");

            if (window.YT_Player !== undefined) {

                window.YT_Player.destroy();

                window.YT_Player = undefined;
                window.YT_vid_id = undefined;
            }

            if (is_wishlist) {
                // event sur le bouton d'ajout à la wishlist
                $("#addToWishlistButton").on("click", addToWishlist);
            }

            // After swiper load, reload dailymotions videos
            try {
                initDailymotionVideos();
            } catch (e) {
                console.error(e);
            }

            //Simulates scroll (2px) to load images
            if (!$('.product_page').length){
                window.scrollTo(0, $(window).scrollTop()+2);
            }

            setTimeout(function() {
                // Resetting alert stock field
                $('.bloc_add_alert_form').hide();
            }, 250);

            //Swiper TG home et produits associés: pas de chargement du swiper, ajout de la class swiper-slide pour l'inté
            //Permet de conserver l'inté du swiper
            if ($(".homepage").length){

                if ($('.swiperTg').length){
                    var model = $('.swiperTg').find($('.swiper-slide'));
                } else if ($('.alt_sld_view').length){
                    var model = $('.alt_sld_view');
                };

                var item = $('.item:not(.swiper-slide)'),
                    newItm = '#itm-' + new_id + (itm_rr_id !== '' ? itm_rr_id.replace('_','-') : '');

                item.css({
                    width: $(model).css('width'),
                    height: $(model).find('imgProd').css('height')
                })

                $(item).find($('.swiper-slide-off')).css('width', '100%');
                item.addClass('swiper-slide');

            }

            //Swiper consultés récemment sur page produit : chargement du lazyload au changement de couleur pour afficher l'image
            if ($(".product_page").length){
                var model;
                var new_itm_id = new_id + (itm_rr_id !== '' ? itm_rr_id.replace('_','-') : '');

                /* MAIN PRODUCT SWIPER + THUMBS */

                var mainSlideFp = $("#jqzoom");
                var thumbSlideFp = $("#visual_scroller");
                setTimeout(function(){
                    if (thumbSlideFp.find(".swiper-wrapper>.swiper-slide").length > 1) {
                        var productThumbs = new Swiper('#visual_scroller', {
                            slidesPerView: 4,
                            spaceBetween: 36,
                            direction: 'vertical',
                            loop: false,
                            navigation: {
                                nextEl: '.thumbNext',
                                prevEl: '.thumbPrev',
                            },
                            threshold: 4,
                            breakpoints: {
                            640: {
                                slidesPerView: 1.25,
                                spaceBetween: 10,
                                centeredSlides: true,
                            },
                            1160: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            1420: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                                centeredSlides: false,
                            },
                            1680: {
                                slidesPerView: 4,
                                spaceBetween: 36,
                                centeredSlides: false,
                            },
                        }
                        });
                    } else {
                        $("#visual_scroller_wrapper").addClass('no_swiper');
                    }
                    if (mainSlideFp.find(".swiper-wrapper>.swiper-slide").length > 1) {
                        //animation to avoid slide's width transition on pageload
                        $('#jqzoom').animate({
                            opacity: 1,
                        },10);
                        var main_productVisu = new Swiper('#jqzoom', {
                            loadOnTransitionStart: true,
                            thumbs: {
                                swiper: productThumbs
                            },
                            pagination: {
                                el: '#jqzoom .swiper-pagination',
                                type: "progressbar"
                            },
                            navigation: {
                                nextEl: '#jqzoom ~ .swiper-button-next',
                                prevEl: '#jqzoom ~ .swiper-button-prev',
                            },
                            slidesPerView: 1,
                            loop: false,
                        });
                    }
                }, 500);
                resetThumbSwiperFP();

                /* PRODUITS ASSOCIES */
                // Produits complementaires *********************************************
                if ($("#gondole_aimerez .swiper-wrapper>.swiper-slide").length > 1) {

                    if ($('.vous_aimerez_aussi').length && !$('.vous_aimerez_aussi').is(':visible')) {
                        $('.vous_aimerez_aussi').show();
                    }
                    var productThumbsaa = new Swiper('#gondole_aimerez', {
                        loop: false,
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                        spaceBetween: 10,

                        navigation: {
                            nextEl: '#gondole_aimerez .swiper-button-nexta',
                            prevEl: '#gondole_aimerez .swiper-button-preva',
                        },
                        pagination: {
                            el: '.complementary_product_pagination',
                            type: 'progressbar',
                        },
                    });
                } else {

                    $("#gondole_aimerez").addClass('no_swiper');

                    if ($('.complementary_product_pagi').length) {
                        $('.complementary_product_pagi').hide();
                    }
                    if ($('.complementary_product_pagination').length) {
                        $('.complementary_product_pagination').hide();
                    }

                    if ($('.swiper-button-nexta').length) {
                        $('.swiper-button-nexta').hide();
                    }
                    if ($('.swiper-button-preva').length) {
                        $('.swiper-button-preva').hide();
                    }
                }

                // Produits similaires *********************************************
                var $gondolSlides = $("#gondole_complete .swiper-wrapper>.swiper-slide");

                if ($gondolSlides.length > 1) {

                    if ($('.similar_product_pagi').length && !$('.similar_product_pagi').is(':visible')) {
                        $('.similar_product_pagi').show();
                    }
                    var productThumbsa = new Swiper('#gondole_complete', {
                        spaceBetween: 10,
                        loop: false,
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        navigation: {
                            nextEl: '#gondole_complete .swiper-button-next',
                            prevEl: '#gondole_complete .swiper-button-prev',
                        },
                        pagination: {
                            el: '.gondole_complete_pagination',
                            type: 'progressbar',
                        },
                    });

                    if ($gondolSlides.length <= 3) {
                        $('#gondole_complete .swiper-button-next, #gondole_complete .swiper-button-prev').hide();
                        $('.gondole_complete_pagination').hide();
                        $('.similar_product_pagi').hide();
                    }
                } else {
                    $("#gondole_complete").addClass('no_swiper');

                    if ($('.similar_product_pagi').length) {
                        $('.similar_product_pagi').hide();
                    }
                }

                /* PRODUITS RECEMMENT CONSULTES */
                var slideCount = $('#recent_see #productVisitedSwiper .swiper-wrapper>.assoc').length;

                if (slideCount >= 1) {
                    if (slideCount <= 5) {
                        $('#recent_see .swiper-pagination').hide();
                        $('#recent_see .swiper-button-next, #recent_see .swiper-button-prev').hide();
                    } else {
                        $('#recent_see .swiper-pagination').show();
                        $('#recent_see .swiper-button-next, #recent_see .swiper-button-prev').show();
                    }

                    var productThumbsaa = new Swiper('#recent_see #productVisitedSwiper', {
                        spaceBetween: 10,
                        loop: false,
                        slidesPerView: 5,
                        navigation: {
                            nextEl: '#recent_see .swiper-button-next',
                            prevEl: '#recent_see .swiper-button-prev',
                        },
                        pagination: {
                            el: '#recent_see .swiper-pagination',
                            type: 'progressbar',
                        },
                    });
                } else {
                    $('#recent_see .swiper-pagination').hide();
                    $('#recent_see .swiper-button-next, #recent_see .swiper-button-prev').hide();
                }
                setTimeout(function(){
                $('#itm-' + new_itm_id).children('.imgProd').css({'opacity':'1'});
                }, 1000);

                $(document).trigger('itmProductReloaded');
            }

            $(document).ready(function() {

                setTimeout(function(){

                    $(window).on('load resize', function () {

                        var img_max_height = $('body.homepage .main_wrapper#site_global_wrap .home-module.simple-gondole .home-column .productVisualMulti').width();
                        $('body.homepage .main_wrapper#site_global_wrap .home-module.simple-gondole .home-column .productVisualMulti').css('max-height', img_max_height);

                        var video_url_link = $('.visited_pdt_holder .productVisualMulti .productBigPictures iframe').width();
                        $('.visited_pdt_holder .productVisualMulti .productBigPictures .video_url').css('min-height', video_url_link);

                        var video_recemment = $('.visited_pdt_holder .swiper-slide .block_lnk iframe').width();

                        $('.mainSlideFp iframe.otherViewImg').height( $('.mainSlideFp iframe.otherViewImg').width() );
                        $('.productVisualMulti.productSwiper iframe').height( $('.productVisualMulti.productSwiper iframe').width());

                        $('.visited_pdt_holder .swiper-slide .block_lnk iframe').css( $('max-height', video_recemment));

                    }).trigger('load resize');
                }, 1000);

            });

            if (($('#dimension_carac').length) > 0) {
                window.setTimeout(function() {
                    $('#dimension_carac .wrapping').overlayScrollbars({});
                }, 1000);
            }

            // Reload sticky behavior on product page
            if (typeof product_sticky_block === 'function') {
                product_sticky_block();
            }
        }
    });
}

function lightboxAlertStock(id, type_alert, produit_page_id) {

    var parent_element = '';
    if ($('#lightbox_achat_express').css('display') == 'block') {
        parent_element = '#lightbox_achat_express ';
    }

    var produit_id;
    if (typeof produit_page_id !== 'undefined' && produit_page_id !== null && produit_page_id !== '') {
        produit_id = String(produit_page_id);
        if (produit_id.indexOf('_') !== -1) {
            produit_id = produit_id.split('_')[0];
        }
    } else {
        produit_id = $(parent_element + '#produit_principal').val() || $(parent_element + '#produit_id').val();
    }

    var $form = $('#lightbox_stock_alert').hasClass('actif')
        ? $(parent_element + '#form_colisage')
        : $(parent_element + '#product_selects');

    var data = $form.serialize();
    data += '&produit_id=' + produit_id;
    data += '&from=nothing';
    data += '&type_alert=' + (type_alert || 'stock');

    $('#bloc_add_alert').addClass('loading');

    $.ajax({
        type: 'post',
        url: path_relative_root + create_link('ajax_lightbox_alert'),
        data: data,
        success: function (response) {
            try {
                response = $.parseJSON(response);
            } catch (e) {
                return;
            }

            if (response.success == 'ok') {
                $('#lightbox_stock_alert').html($(response.datas.html));
            }
        },
        complete: function () {
            if (!$('#lightbox_stock_alert').hasClass('actif')) {
                openMultiShad('lightbox_stock_alert');
            }
            $('#bloc_add_alert').removeClass('loading');
        }
    });

}

function loadcolor() {
    $("body.product_page").on("click", "#more_coloris", function(){
        $("body.product_page .choices_list").addClass("show_all");
        $("body.product_page #more_coloris").hide();
    });
}

/**
 * @param product_id : l'id du produit
 * @param regroup_ref_id : l'id du regroupement (si exist)
 * use in : app/views/_components/product/achat_express.php
 */
function achatExpressV2(product_id, regroup_ref_id) {
    var btn = $(this);
    // Loader
    btn.parent('.form_submit').addClass('loading');
    var elem = regroup_ref_id ? '_' + product_id + regroup_ref_id : '_' + product_id;
    var form = document.getElementById('prod_info' + elem);
    var color_id = form.elements['couleurProd'].value;
    var size_id = form.elements['tailleProd'].value;
    // Vérification si la taille sélectionnée n'est pas désactivée ce qui permet d'afficher l'alerte stock
    var tailleProdCrossSell = $('#qteProd_' + product_id + regroup_ref_id);

    var sizeQnt = form.elements['cnt_sizes'] ? form.elements['cnt_sizes'].value :  $('#cnt_sizes' + product_id + '_' + regroup_ref_id);
    var colorQnt = form.elements['cnt_colors'] ? form.elements['cnt_colors'].value :  $('#cnt_colors_' + product_id + '_' + regroup_ref_id);
    if (colorQnt > 1 && regroup_ref_id === '') {
        $( ".form_itm.color input[name='itm_color']" ).each(function( index ) {
            $(this).prop( "checked", false );
        });
        $("#ligne_couleur_" + product_id + regroup_ref_id).fadeIn(600);
    } else if (colorQnt < 2 && sizeQnt > 1) {
        // Here we only have one color and several sizes, be sure to check availability when size selected
        $("#ligne_pointure_" + product_id + regroup_ref_id).fadeIn(600);
    } else {
        if (($('#size_' + product_id + "_" + size_id + regroup_ref_id, $('#prod_info' + elem)) != undefined && $('#size_' + product_id + "_" + size_id + regroup_ref_id, $('#prod_info' + elem)).length == 1 && $('#size_' + product_id + "_" + size_id + regroup_ref_id, $('#prod_info' + elem)).hasClass('disabled')) || ($('#tailleProd_' + product_id + '_' + regroup_ref_id).value == '0') || (typeof tailleProdCrossSell[0] != "undefined" && tailleProdCrossSell[0].value == "0")) {
            $(this).parent().hide();
            $('#bloc_add_alert' + elem).show();
        } else { // On ajoute bien le produit en faisant les vérifications sur la taille et la couleur
            // On regarde si la personne a sélectionenr la taille et la couleur
            if (color_id !== '' && size_id !== '') {
                if ($('.cartAssocSlider').length) {

                    waitingAddToBasket(event, form, 'basket', regroup_ref_id);
                } else {

                    waitingAddToBasket(event, form, '', regroup_ref_id);
                }

                setTimeout(function() {
                    btn.parent('.form_submit').removeClass('loading');
                }, 2000);
            } else if (color_id === '' && size_id === '') {
                alert(translate('choose_a_size_and_a_color'));
                // Loader
                btn.parent('.form_submit').removeClass('loading');
            } else if (color_id === '') {
                alert(translate('choose_a_color'));
                // Loader
                btn.parent('.form_submit').removeClass('loading');
            } else if (size_id === '') {
                alert(translate('choose_a_size'));
                // Loader
                btn.parent('.form_submit').removeClass('loading');
            }
        }
    }

    //Allow to keep the heart filled for products in the wishlist when another product is moved to basket
    setTimeout(function () {
        getWishlistProducts();
    }, 1200);
}

// Called upon size change in product page
function onItemSizeChange(form, is_regroup, itm_rr_id) {
    var control;
    var isWishList = $('#wishlist').length > 0;
    var isAchatExpressV2 = ($('#is_achat_express_v2').val() == 1 && !isWishList);
    var productId = form.getValue('produit_id');
    var elem = isAchatExpressV2 ? '_' + productId + itm_rr_id : '';
    var productRef = form.getValue('produit_ref');
    control = form.elements.namedItem('tailleProd');
    control.value = this.value.trim();
    var from  = ($('#is_from_lookbook').val() !== undefined) ? 'lookbook' : 'product';
    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';

    if (isAchatExpressV2) {
        if (this.checked) {
            if (window.dataLayer !== undefined) {
                pushToWshopBus({
                    'event': 'changeSize',
                    'produit': {
                        'size_value': ($(this).attr('data-nom')),
                    }
                });
                if (window.dataLayer[0].product) {
                    window.dataLayer[0].product.size = ($(this).attr('data-nom'));
                }
            }

            if ($('#sizeerror').is(':visible')) {
                $('#sizeerror').slideUp();
            }

            loadProduct.call(form, productId, 'taille', from, itm_rr_id, 'sizeChange');

            // Depending on the color we see if the product is available, do this only in product page
            // We check if the product is already in the wishlist
            checkProductInWishlist(productId, productRef, true);
        }
    } else {
        if (window.dataLayer !== undefined) {
            pushToWshopBus({
                'event': 'changeSize',
                'produit': {
                    'size_value': ($(this).attr('data-nom')),
                }
            });
            if (window.dataLayer[0].product) {
                window.dataLayer[0].product.size = ($(this).attr('data-nom'));
            }
        }

        if ($('#sizeerror').is(':visible')) {
            $('#sizeerror').slideUp();
        }
        if (is_regroup) {
            loadProduct.call(form, productId, 'taille', from, itm_rr_id, 'sizeChange');
        } else if (!isWishList) {
            // No such color for this size: switch to an existing one, its handler refreshes the visual and the stock
            if (!selectExistingPair(form, 'itm_color', this.value)) {
                // Refresh the stock state for the new size / color pair
                getAvailableQuantity.call(form, productId, false, '');
            }
        }

        // DO NOT DELETE COMMENT IN CASE EVO REGROUP NOT DONE *************************************************************************************
        // Depending on the color we see if the product is available, do this only in product page
        // We check if the product is already in the wishlist
        checkProductInWishlist(productId, productRef, true);
    }
}

/**
 * @description Called upon color change in product page
 */
function onItemColorChange(form, is_regroup, itm_rr_id) {

    var control, prod_id, from_page;
    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';
    var is_wishlist = $('#wishlist').length > 0;
    var is_achat_express_v2 = ($('#is_achat_express_v2').val() == 1 && !is_wishlist);

    if (this.checked) {
        control = form.elements.namedItem(form.getValue('idCouleur'));
        control.value = this.value.trim();

        // If it is achat_express_v2
        if (is_achat_express_v2 && ($('[name="itm_id_' + control.value + itm_rr_id + '"]').length > 1)) {
            // Find the input_check checked and look at your parent to find the right name=itm_id_.. inside as there are more than one
            var checkedColor_input = $(form).find('.input_check:checked');
            var checkedColor_value = checkedColor_input.parent().find('[name="itm_id_' + control.value + itm_rr_id + '"]').val();
            prod_id = checkedColor_value;
        } else {
            prod_id = form.getValue('itm_id_' + control.value + itm_rr_id).trim();
        }

        var is_assoc_product = form.getValue('isAssocProduct') ? form.getValue('isAssocProduct') : 0;

        if (is_assoc_product == true) {
            from_page = 'assoc';
        } else {
            from_page = 'product';
        }

        if (is_regroup) {
            loadProduct.call(form, prod_id, 'couleur', from_page, itm_rr_id, 'colorChange');
        } else {
            // Check if the product is already in the wishlist
            if (!is_achat_express_v2) {
                checkProductInWishlist(prod_id, itm_rr_id);
            } else {
                loadProduct.call(form, prod_id, 'couleur', from_page, itm_rr_id, 'colorChange', false);
            }

            var img = $(this).data('pic');
            changeVisu('img_large', img);

            // Define sizes that still have stock
            setAvailableSizes.call(this);

            // Refresh the stock state for the new size / color pair
            if (!is_achat_express_v2 && !is_wishlist) {
                // No such size for this color: switch to an existing one
                selectExistingPair(form, 'itm_size', this.value);
                getAvailableQuantity.call(form, prod_id, false, '');
            }
        }
    }
}

// Refreshes available quantity
function getAvailableQuantity(id, qty, from, idCouleur, itm_rr_id, is_wishlist) {
    itm_rr_id = (itm_rr_id !== undefined) ? itm_rr_id : '';
    var form = (this instanceof HTMLFormElement) ? this : document.getElementById('prod_info_' + id + itm_rr_id);
    var list = $('.qte_select_wrapper', form).get(0);
    var pcol = form.getValue('idCouleur_' + id + '_' + itm_rr_id);
    if (typeof (pcol) == 'undefined') {
        var pcol = form.getValue('idCouleur');
    }

    var qty = (qty !== undefined) ? qty : 1;
    var is_achat_express = $('#is_achat_express_v2').val() == 1 && !is_wishlist;

    id = ((id !== undefined) ? id : '' );

    var val_color = form.getValue(pcol);
    if (val_color == '0') {
        val_color = 'none';
    }

    var psze = form.getValue('idTaille');
    var val_size = form.getValue(psze);
    if (val_size == '0') {
        val_size = 'none';
    }

    if (idCouleur !== undefined) {
        val_color = idCouleur;
        $('#' + pcol).val(idCouleur);
        $("#color_" + idCouleur).attr("checked", "checked");
    }

    var data = {
        idprod : form.getValue('produit_id'),
        idcouleur : val_color,
        idtaille : val_size,
        json: '1'
    };

    if (from == 'basket') {
        data.suff = form.getValue('produit_id');
    }

    var product_has_stock;

    $.ajax({
        url : path_relative_root + 'ajax_liste_qte.php',
        type : 'get',
        async : false, // Should be async but would then need a loader so...
        data : data,
        dataType: 'json',
        success : function (res) {
            var new_select;
            if (list) {
                list.innerHTML = res.content.trim();

                if (qty) {
                    new_select = form.elements.namedItem('qteProd');
                    if ($('[value="' + qty + '"]', new_select).length > 0) {
                        new_select.value = qty;
                    } else {
                        new_select.value = $('option:last', new_select).val();
                    }
                }
            }

            if ($("#date_du_ajax").val() == 0 && $("#date_au_ajax").val()) {
                $("#delivery_delay").hide();
            } else {
                $("#delivery_delay").show();
                $("#date_du").html($("#date_du_ajax").val());
                $("#date_au").html($("#date_au_ajax").val());
            }

            if ($('.txt_reason_borne').length > 0) {
                $('.info_magasin').html($('.txt_reason_borne').html());
                $('.info_magasin').show();
            }

            $('#liste_qte').html(res.content);
            $(".eclatProd").show();
            $(".precoDeliveryDate").show();

            if (!is_achat_express) {
                if ($('#case_ajax') !== 'undefined') {
                    let stockCase = $('#case_ajax').val();
                    if (['5', '6', '7'].includes(stockCase)) {
                        $(".product_left_wrapper .eclat_nouveaute").removeClass('cache');
                        $(".product_left_wrapper .eclat_epuise").addClass('cache');
                        $(".eclatProd").removeClass('cache');

                        $("#bloc_add_alert").removeClass('cache');
                        $("#btn_alert_stock").removeClass('cache').show();
                        $("#bloc_add_basket").addClass('cache');

                        $(".stock_info.yes").addClass('cache');
                        $(".stock_info.no").removeClass('cache');
                        $(".productQuantityFieldset").addClass("without_stock");
                        $(".qte_select_wrapper").addClass("without_stock");
                        $(".stock_delivery").addClass('cache');
                    } else if (stockCase == '8') {
                        $(".product_left_wrapper .eclat_epuise").removeClass('cache');
                        $(".product_left_wrapper .eclat_nouveaute").addClass('cache');
                        $(".eclatProd").addClass('cache');

                        $("#bloc_add_basket").removeClass('cache');
                        $("#btn_add_cart").attr('disabled', true);
                        $('.disabledBtnTooltip').addClass('cache');
                        $("#bloc_add_alert").addClass('cache');
                        $("#btn_alert_stock").hide();

                        $(".stock_info.yes").addClass('cache');
                        $(".stock_info.no").removeClass('cache');
                        $(".productQuantityFieldset").addClass("without_stock");
                        $(".qte_select_wrapper").addClass("without_stock");
                        $(".stock_delivery").addClass('cache');
                    } else { // Case 1 / 2 / 3 / 4
                        $(".product_left_wrapper .eclat_epuise").addClass('cache');
                        $(".product_left_wrapper .eclat_nouveaute").addClass('cache');
                        $(".eclatProd").removeClass('cache');

                        $("#bloc_add_basket").removeClass('cache');
                        $("#btn_add_cart").attr('disabled', false);
                        $("#bloc_add_alert").addClass('cache');
                        $("#btn_alert_stock").hide();
                        $(".stock_info.yes").removeClass('cache');
                        $(".stock_info.no").addClass('cache');
                        $(".productQuantityFieldset").removeClass("without_stock");
                        $(".qte_select_wrapper").removeClass("without_stock");
                        $(".stock_delivery").removeClass('cache');

                        // DATALAYER V2
                        pushIntoDatalayer(res.dataLayer_object);
                    }
                }
            } else {
                if (res.stock_tampon == 0) {
                    if (wShop.$refs.wAlertestockForm) {
                        wShop.$refs.wAlertestockForm.reloadBloc += 1;
                    }

                    // DATALAYER V2
                    pushIntoDatalayer(res.dataLayer_object);
                    product_has_stock = false;
                } else {
                    // DATALAYER V2
                    pushIntoDatalayer(res.dataLayer_object);
                    product_has_stock = true;
                }
            }

            if ($('.shipping_fees').length > 0) {
                if (res.inventory && res.inventory.enableAddToCart === false) {
                    $('.shipping_fees').addClass('cache').removeClass('is-loading');
                    return;
                }

                const shippingFees = res.shippingFees || {};
                if (!shippingFees || !shippingFees.relay || !shippingFees.home || !shippingFees.store) {
                    $('.shipping_fees').addClass('cache').removeClass('is-loading');
                    return;
                }

                $('.shipping_fees').removeClass('cache');

                const relay = shippingFees.relay;
                const home = shippingFees.home;
                const store = shippingFees.store;
                const currencyDisplay = res.currency ? ' ' + res.currency.trim() : '';

                function formatPriceValue(value) {
                    const num = parseFloat(value);
                    return (num % 1 === 0) ? num.toString() : num.toFixed(2).replace('.', ',');
                }

                function formatEstimateDate(estimateProp) {
                    if (!estimateProp) return '';
                    let dateStr = (typeof estimateProp === 'object' && estimateProp.date) ? estimateProp.date : estimateProp;
                    if (!dateStr || dateStr === "false" || typeof dateStr !== 'string') return '';
                    const cleanDateStr = dateStr.split('.')[0].replace(/-/g, "/");
                    const date = new Date(cleanDateStr);
                    if (isNaN(date.getTime())) return '';
                    return ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2);
                }

                const relayBlockShippingFees = $('.shipping-fee-relay');

                if (relay.carrier_id !== false && relay.carrier_id !== "false") {

                    if (relay.threshold_crossed === true) {
                        relayBlockShippingFees.find('.js-threshold-text').html(Translator.translate('delivery_amount_free'));
                    } else {
                        const thresholdVal = parseFloat(relay.threshold);

                        if (relay.threshold !== null && relay.threshold !== false && thresholdVal > 0) {
                            const thresholdDisplay = formatPriceValue(thresholdVal) + currencyDisplay;
                            relayBlockShippingFees.find('.js-threshold-text').html(Translator.translate('free_delivery_for_over_X', thresholdDisplay));
                        } else {
                            relayBlockShippingFees.find('.js-threshold-text').html('');
                        }
                    }

                    const dateFrom = formatEstimateDate(relay.estimate?.from);
                    const dateTo = formatEstimateDate(relay.estimate?.to);

                    relayBlockShippingFees.find('.js-delivery-status')
                        .attr('class', 'delivery-available js-delivery-status')
                        .html(Translator.translate('delivered_between_date_and_date_shipping_fee', `<b>${dateFrom}</b>`, `<b>${dateTo}</b>`));
                } else {
                    relayBlockShippingFees.find('.js-threshold-text').html('');
                    relayBlockShippingFees.find('.js-delivery-status')
                        .attr('class', 'delivery-not-available js-delivery-status')
                        .html(Translator.translate('not_eligible_product'));
                }

                const homeBlockShippingFees = $('.shipping-fee-home');
                if (home.carrier_id !== false && home.carrier_id !== "false") {
                    const feeVal = parseFloat(home.fee);
                    if (home.fee !== false && feeVal > 0) {
                        const feeDisplay = formatPriceValue(feeVal) + currencyDisplay;
                        homeBlockShippingFees.find('.js-fee-text').html(Translator.translate('from_less_expensive_shipping_fee', feeDisplay));
                    } else {
                        homeBlockShippingFees.find('.js-fee-text').html('');
                    }
                    const dateFrom = formatEstimateDate(home.estimate?.from);
                    const dateTo = formatEstimateDate(home.estimate?.to);

                    homeBlockShippingFees.find('.js-delivery-status')
                        .attr('class', 'delivery-available js-delivery-status')
                        .html(Translator.translate('delivered_between_date_and_date_shipping_fee', `<b>${dateFrom}</b>`, `<b>${dateTo}</b>`));
                } else {
                    homeBlockShippingFees.find('.js-fee-text').html('');
                    homeBlockShippingFees.find('.js-delivery-status')
                        .attr('class', 'delivery-not-available js-delivery-status')
                        .html(Translator.translate('not_eligible_product'));
                }

                const storeBlockShippingFees = $('.shipping-fee-store');

                if (store.carrier_id !== false && store.carrier_id !== "false") {
                    const days = parseInt(store.estimate?.days || 0, 10);
                    storeBlockShippingFees.find('.js-delivery-status')
                        .attr('class', 'delivery-available js-delivery-status')
                        .html(Translator.translate('in_xxx_days', days));
                } else {
                    storeBlockShippingFees.find('.js-delivery-status')
                        .attr('class', 'delivery-not-available js-delivery-status')
                        .html(Translator.translate('not_eligible_product'));
                }

                $('.shipping_fees').removeClass('is-loading');
            }
        }
    });

    if (is_achat_express) {
        return product_has_stock;
    }
}

function waitingAddToBasket(evt, form_elm, from, itm_rr_id) {

    var id = '';
    var produit_id = form_elm.getValue('produit_id');
    var produit_refext = form_elm.getValue('produit_refext');
    var suff = form_elm.getValue('suff');
    var panier_id = form_elm.getValue('panier_id');
    var titreObjet = form_elm.getValue('titreObjet');
    var idTaille = form_elm.getValue('idTaille');
    var lastTaille = form_elm.getValue('lastTaille');
    var idCouleur = form_elm.getValue('idCouleur');
    var lastCouleur = form_elm.getValue('lastCouleur');
    var toEval = form_elm.getValue('toEval');
    var page_name = form_elm.getValue('page_name');
    var path_web = form_elm.getValue('path_web');
    var enable_omniture = form_elm.getValue('enable_omniture');
    var is_not_produit = form_elm.getValue('is_not_produit');
    var is_lightbox_specifique = form_elm.getValue('is_lightbox_specifique');
    var is_achat_express = $('#is_achat_express_v2').val() == 1;
    var loader;

    if (!is_achat_express) {
        evt.preventDefault();
    }

    if (from === undefined) {
        from = '';
    }

    if (is_not_produit == true) {
        id += '_' + produit_id;
    }

    if (from == 'product') {
        if (this.nextElementSibling && this.nextElementSibling.classList.contains('loader')) {

            loader = $(this.nextElementSibling);
            loader.addClass("loading");
        } else {

            $("#bloc_btn_active" + id).attr('class', 'cache');
            $("#bloc_btn_loader" + id).attr('class', 'f_right');
        }
    }

    if (is_lightbox_specifique == 'true') {
        add_produit_specifique(produit_id, idCouleur, idTaille);
    } else {
        window.setTimeout(addToBasket, 1000, produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, is_achat_express, itm_rr_id);
    }

    //Allow to keep the heart filled for products in the wishlist when another product is moved to basket
    setTimeout(function () {
        getWishlistProducts();
    }, 1000);
}

function addToBasket(produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, is_achat_express, itm_rr_id)
{
    var id = '';
    prix_id = 'prixU';

    if (from == 'basket' || is_not_produit == true || is_achat_express) {
        id += '_' + produit_id + itm_rr_id;
        prix_id = 'prixU' + id;
        if (is_not_produit == true) {
            var code_color = $('#couleurUnique' + id).text();
            var nom_color = $('#couleurUnique' + id).text();
        }
    }

    var array_panier = newUpdatePanier(produit_id, suff, panier_id, document.getElementById(prix_id).value, path_web, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur);

    if (array_panier != false) {
        if (from == 'basket') {
            location.reload();
            return false;
        }

        var type = '';

        if (array_panier[1] == 'false' || array_panier.length == 0) {
            type = 'err';
        }

        omnitureEvent = '';
        if (array_panier[1] == 1) {
            omnitureEvent = 'scOpen,scAdd';
        } else {
            omnitureEvent = 'scAdd';
        }

        if (loader) {
            loader.removeClass('loading');
        } else {
            $("#bloc_btn_active" + id).attr('class', '');
            $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
        }

        if (array_panier[1] > 0 && enable_omniture == true) {
            void(s.t());
            s.pageName = "'" + page_name + "'";
            s.products = ";" + produit_id;
            s.events = omnitureEvent;
            void(s.t());
        }

        if (array_panier.length >= 0 && array_panier[5] !== undefined) {
            pushIntoDatalayer(array_panier[5]);
        }

        // DATALAYER V3
        if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null) {
            if (array_panier.length >= 0 && array_panier[6] !== undefined) {
                var dlv3_objet;
                try {
                    dlv3_objet = JSON.parse(array_panier[6]);
                    // Push into Datalayer
                    if (dlv3_objet !== undefined) {
                        DataLayerTrigger.addToCart(dlv3_objet['items'], dlv3_objet['actionField'], is_achat_express);
                         if (typeof algolia_enabled !== 'undefined' && algolia_enabled == true) {
                             storeAlgoliaSearchConversion(datalayer_v3_object);
                         }
                    }
                } catch (e) {
                }
            }
        }

        // Mise à jour du panier top
        var response_basket = ajax_file(path_web + create_link('ajax_show_basket'));

        $("#cart_top").html(response_basket);

        $("#cart_top .cart_product_listing").overlayScrollbars({});

        if (from != 'basket') {

            newshowmodal(produit_id, is_not_produit);
        }
    } else {
        if (loader) {
            loader.parent().removeClass('loading');
        } else {
            $("#bloc_btn_active" + id).attr('class', '');
            $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
        }
    }

    eval(toEval);

    if (array_panier != false) {
        if (navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1) {
            var svn = document.getElementsByTagName("SELECT");
            for (a = 0; a < svn.length; a++) {
                svn[a].style.visibility = "hidden";
            }
        }
    }

    return false;
}

/***** FUNCTION PUSH INTO DATALAYER  *****/

function pushIntoDatalayer (data) {
    if (typeof(data) == 'object') {
        pushToWshopBus(data);
    } else if (typeof(data) == 'string') {
        pushToWshopBus(JSON.parse(data));
    }
}

// Alters item quantity in cart
function chanQteList() {
    var item = this.getValue('item_id', parseFloat);
    var loader = document.getElementById('qte_loader_' + item);

    var old_qte = parseInt($(this).find('.selected_qte').val());
    var new_qte = parseInt($(this).find('.qnt_prod').val());
    var rank = $(this).index('.qte_selector');
    this.qtty_select_wrap.style.display = 'none';
    loader.style.display = 'block';

    if (window.dataLayer !== undefined) {
        var product = productFieldObject[rank];

        if (new_qte > old_qte) {
            product.quantity = (new_qte - old_qte);
            pushToWshopBus({
                "event": "addToCart",
                "ecommerce": {
                    'currencyCode': siteCurrency.code,
                    "add": {
                        "products": [product]
                    }
                }
            });
            if (typeof dataLayer_v3 !== 'undefined' && typeof dl_v3_impressions !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null) {
                DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, product.id, "add_to_cart", product.quantity);
            }
        } else if (new_qte < old_qte) {
            product.quantity = (old_qte - new_qte);
            pushToWshopBus({
                "event": "removeFromCart",
                "ecommerce": {
                    "remove": {
                        "products": [product]
                    }
                }
            });
            if (typeof dataLayer_v3 !== 'undefined' && typeof dl_v3_impressions !== 'undefined' && dataLayer_v3 !== '' && dataLayer_v3 !== null && product.quantity > 0) {
                DataLayerTrigger.cart_product_action(dl_v3_impressions, dlv3_action_fields, product.id, "remove_from_cart", product.quantity);
            }
        }
    }

    $.ajax({
        url : path_relative_root + create_link("order_basket"),
        type : 'post',
        data : {
            action : 'del',
            panierId : item,
            cad  : 'non',
            pointcad : 0,
            qteProd : new_qte,
            change_qte : true
        },
        cache : false,
        success : function (res) {
            try {
                res = JSON.parse(res);
            } catch (e) {
                console.error('JSON ERROR: could not parse data');
                return false;
            }

            resHtml = $('<div />').html(res.datas);

            document.getElementById('main_cart_wrapper').innerHTML = $('#main_cart_wrapper', resHtml).html();
            if (wShop.$refs.wCouponForm) {
                wShop.$refs.wCouponForm.reloadBloc+=1;
            }

            // Cart slider initialization
            var sliderCart = $('#main_cart_wrapper #basketAssocWrapper');

            if (sliderCart.length) {
                sliderCart.remove();
            }

            //update top cart
            var response = ajax_file(create_link('ajax_show_basket'));
            document.getElementById('cart_top').innerHTML = response;

            if (res.error_message.length) {
                $('#modboxpromo').find('.texte').html(res.error_message);
                openMultiShad('modboxpromo');
            }
        },
        complete : function() {
            var total = $('#cart_top .link_item_cart').attr('data-cart'),
            cart = Translator.translate('mon_panier'),
            text;
            if (total <= 1){
                text = Translator.translate('one_product');
            } else {
                text = Translator.translate('2_product');
            };

            //Simulates scroll (2px) to load images
            setTimeout(function() {
                window.scrollTo(0, $(window).scrollTop()+3);
            }, 100);

            getWishlistProducts();
        }
    });
}

/**
 * Tunnel FAQ
 */
function fadePanier(id, nbelem) {

    for (var i = 1; i <= nbelem; i++) {
        if (id != i && $("#texte_question_" + i).css('display') == 'block') {
            $("#texte_question_" + i).slideUp(400);
            $("#intitule_question_" + i).removeClass('actif');
        }
    }

    if ($("#texte_question_" + id).css('display') != 'block') {
        $("#texte_question_" + id).slideDown(400);
        $("#texte_question_" + id).addClass('actif');
        $("#intitule_question_" + id).addClass('actif');
    } else {
        $("#texte_question_" + id).slideUp(400);
        $("#texte_question_" + id).removeClass('actif');
        $("#intitule_question_" + id).removeClass('actif');
    }
}

function newshowmodal(products, type, root, id_produit, is_not_produit) {
    topCartAppear();

    window.setTimeout(function () {
        if (!$("#cart_top").is(":hover")) { // If the mouse is not over the cart
            topCartDesappear();
        }
    }, 2000);
}

function topCartAppear() {
    var cart_top = $('#cart_top');
    cart_top.addClass('active_rollover')

    $('#show_top_cart #order_basket_list').overlayScrollbars({
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 0,
        }
    });

    $('#shad_menu').addClass("actif");
}

function topCartDesappear() {
    var cart_top = $('#cart_top');

    cart_top.removeClass('active_rollover')
    $('#shad_menu').removeClass("actif");
}

$.fn.selectChangeAdr = function() {
    var $obj = $(this);
    var obj_val = $obj.val();
    var id_transp = $obj.attr("id");
    var data = {};
    var $changeContainer = $(
        ".wrapper_form_adresse",
        $obj.closest(".adresse_change")
    );
    data.act = "ajout";
    data.id_transp = id_transp;
    data.no_encode_ajax = true;
    data.modif_type = "ajax";

    if (obj_val != "") {
        if (obj_val != 0) {
            data.idAdresse = obj_val;
            data.act = "modif";
        }
        if ($changeContainer.is(".show")) {
            $changeContainer
                .removeClass("show")
                .slideUp()
                .html("");
        }
        $.ajax({
            type: "get",
            data: data,
            url: path_relative_root + create_link('livraison-ajax'),
            success: function(response) {
                var $responce = $(response);
                var min_form = $(".min_form", $responce).html();
                var $form = $("#adresseForm", $responce);
                var all_form;

                $changeContainer
                    .html($form.html(min_form))
                    .css({display: "none"})
                    .slideDown();
                if (!$changeContainer.is(".show")) {
                    $changeContainer.addClass("show").slideDown();
                }
                try {
                    new DeliveryPage().init();
                } catch (e) {
                    console.error(e);
                }
                initialize_google_place("delivery");
                $(".type_adresse", ".choix_type_adresse.delivery").on(
                    "click",
                    function() {
                        $(this).show_adresse_title(
                            $(".type_adresse", ".choix_type_adresse.delivery"),
                            "#adresseTitre"
                        );
                    }
                );

                var country_select = "";

                if (typeof $("#pays").val() != "undefined") {
                    country_select = $("#pays")
                        .find(":selected")
                        .data("role")
                        .toLowerCase();

                    $("#pays").change(function() {
                        if (
                            typeof $(this)
                                .find(":selected")
                                .data("role") != "undefined"
                        ) {
                            country_select = $(this)
                                .find(":selected")
                                .data("role")
                                .toLowerCase();
                        }

                        if (typeof $("#telephone").val() != "undefined") {
                            $("#telephone").intlTelInput(
                                "setCountry",
                                country_select
                            );
                        }

                        if (typeof $("#mobile").val() != "undefined") {
                            $("#mobile").intlTelInput(
                                "setCountry",
                                country_select
                            );
                        }
                    });
                } else {
                    country_select = "fr";
                }
            },
        });
    }
};

var mainProductSwiper = null;
function changeVisu(field, path, evt) {
    var new_img, target, current;

    field = document.getElementById(field);

    if (evt) {
        target = evt.target.parentElement;
        current = target.parentElement.getElementsByClassName("current");

        target.classList.add("current");

        Array.prototype.slice.call(current).forEach(function(elm) {
            if (elm !== target) {
                elm.classList.remove("current");
            }
        });
    }

    if (field && field.parentElement) {
        new_img = new Image();

        new_img.id = field.id;
        new_img.className = field.className;

        new_img.addEventListener("load", function() {
            this.alt = field.alt;

            this.setAttribute("width", this.naturalWidth);
            this.setAttribute("height", this.naturalHeight);

            if (field.parentElement) {
                field.parentElement.appendChild(this);
                field.parentElement.removeChild(field);
            }
        });

        new_img.src = path;
    }

    if (!mainProductSwiper) {
        mainProductSwiper = new Swiper(".productSwiper", {
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.rollover_rayonsNext',
                prevEl: '.rollover_rayonsPrev',
            },
            preloadImages: false,
            lazy: true,
            loadPrevNext: true,
            loadOnTransitionStart: true
        });
    }
}

function closeAlerteStock(elem) {
    // Hide bloc alert stock
    $('.bloc_add_alert_' + elem).hide();
}

/*
 * Permet l'envoi du mail qui confirme l'enregistrement de sont email, pour alerter la personne quand le produit sera disponible
 */
function sendMailAlertStock(type_alert, form, itm_rr_id) {

    itm_rr_id = itm_rr_id !== undefined ? itm_rr_id : '';
    var id = form.getValue('produit_id');
    var is_achat_express = $('#is_achat_express_v2').val() !== undefined;
    var elem = is_achat_express ? '_' + id + itm_rr_id : '';

    var $email = $('#mail_alerte_stock' + elem).val(),
        $produit_id = $('#produit_principal' + elem).val(),
        $taille_id = $("#tailleProd" + elem).val(),
        $couleur_id = $("#couleurProd" + elem).val(),
        $type_alert = type_alert;

    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    var mail_value = $('#mail_alerte_stock' + elem).val();
    $verif_mail = mail_value.match(mailformat);

    if ($email == '' || !$verif_mail) {

        $('#mail_alerte_stock' + elem).addClass('inputErr');
    } else {

        $('#mail_alerte_stock' + elem).removeClass('inputErr');
        $.ajax({
            type: 'post',
            url: path_relative_root + create_link('ajax_mail_alert_stock'),
            data: {
                email: $email,
                produit_id: $produit_id,
                taille_id: $taille_id,
                couleur_id: $couleur_id,
                type_alert: $type_alert
            },
            success: function(response) {
                DataLayerTrigger.alertStock();
                $('.bloc_add_alert' + elem + ' .alert_stock').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_erreur').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_form').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_confirmation').show();
            },
            fail: function() {
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_confirmation').hide();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_erreur').show();
                $('.bloc_add_alert' + elem + ' .bloc_add_alert_form').show();
            }
        });
    }
}

/**
 * Product page without regroup: when the selected size / color pair does not exist,
 * selects the first existing value of the other axis (in stock first)
 * @param {HTMLFormElement} form
 * @param {string} name input name to switch ('itm_size' or 'itm_color')
 * @param {string} value value just selected on the other axis
 * @return {boolean} true if a value has been switched
 */
function selectExistingPair(form, name, value) {
    var pairs = window.product_size_color_pairs;
    var stocks = {};

    if (!pairs || typeof pairs !== 'object') {
        return false;
    }

    // stocks = { id of the axis to switch: has stock } for the selected value
    for (var color_id in pairs) {
        if (!pairs.hasOwnProperty(color_id) || color_id === 'stock_quantite') {
            continue;
        }

        if (name === 'itm_size') {
            if (color_id == value) {
                stocks = pairs[color_id];
            }
        } else if (pairs[color_id].hasOwnProperty(value)) {
            stocks[color_id] = pairs[color_id][value];
        }
    }

    var inputs = $('[name="' + name + '"]', form).filter(function () {
        return stocks.hasOwnProperty(this.value);
    });
    var current = $('[name="' + name + '"]:checked', form).val();

    if (!inputs.length || stocks.hasOwnProperty(current)) {
        return false;
    }

    var target = inputs.filter(function () {
        return stocks[this.value];
    }).get(0) || inputs.get(0);

    if (name === 'itm_size') {
        target.checked = true;
        form.elements.namedItem(form.getValue('idTaille')).value = target.value;
    } else {
        // Native click: checks the color then runs its onchange (visual + stock)
        target.click();
    }

    return true;
}

/**
 * Permet de récupérer les stocks des tailles par couleur ainsi que leur stock
 * @return  void
 */
function setAvailableSizes() {
    if (window.json_colisages !== undefined) {
        var sizes_tab = window.json_colisages[$(this).val()];
        var size_box, is_disabled;
        var has_stock = false;

        for (size_id in sizes_tab) {
            if (sizes_tab.hasOwnProperty(size_id)) {
                size_box = $('.product_main_wrapper [name="itm_size"]').filter('[value="' + size_id + '"]');
                is_disabled = !sizes_tab[size_id];
                if (is_disabled) {
                    size_box.addClass('disabled');
                } else {
                    size_box.removeClass('disabled');
                    has_stock = true;
                }
            }
        }

        if (has_stock) {
            $("#btn_add_cart").removeClass('cache');
            $('.eclat_nouveaute').addClass('cache');
            $(".eclat_epuise").addClass('cache');
        } else {
            if ($('#case_ajax') !== 'undefined') {
                let stockCase = $('#case_ajax').val();
                if (['5', '6', '7'].includes(stockCase)) {
                    $(".eclat_nouveaute").removeClass('cache');
                    $(".eclat_epuise").addClass('cache');
                    $(".eclatProd").removeClass('cache');
                    $("#bloc_add_alert").removeClass('cache');
                    $("#btn_add_cart").addClass('cache');
                } else if (stockCase == '8') {
                    $(".eclat_epuise").removeClass('cache');
                    $(".eclat_nouveaute").addClass('cache');
                    $(".eclatProd").addClass('cache');
                    $("#btn_add_cart").addClass('cache');
                    $("#bloc_add_alert").addClass('cache');
                } else { // Case 1 / 2 / 3 / 4
                    $(".eclat_epuise").addClass('cache');
                    $(".eclat_nouveaute").addClass('cache');
                    $(".eclatProd").removeClass('cache');
                    $("#btn_add_cart").removeClass('cache');
                    $("#bloc_add_alert").addClass('cache');
                }
            }
        }
    }
}

function btnLoaderUnloading(btn) {

    "use strict";

    var loader = btn.next(".loader");

    if (loader.length > 0) {

        setTimeout(function(){loader.removeAttr("style").parent().removeClass("loading")}, 200);
    }
}

// FERMER EN SAVOIR PLUS CONNEXION

function close_popup(elem) {
    var $modbox = $("#" + elem);
    var $shad = $("#shad");
    var keepPdvOpen = elem === 'popup_savoir_plus' && $('#pdvBox').hasClass('actif');
    var keepStockAlertOpen = elem === 'popup_savoir_plus' && $('#lightbox_stock_alert').hasClass('actif');

    $modbox.removeClass("actif");

    if (elem === 'popup_savoir_plus') {
        if (keepPdvOpen) {
            $shad.addClass('actif').off('click.multiShad').on('click.multiShad', function () {
                closeMultiShad('pdvBox');
            });
        } else if (keepStockAlertOpen) {
            $shad.addClass('actif').addClass('below_header').off('click.multiShad').on('click.multiShad', function () {
                closeMultiShad('lightbox_stock_alert');
            });
        } else {
            $shad.removeClass("actif");
        }
    } else {

        $shad.attr("onclick", "");
        $shad.animate({opacity: 0}, 350, function() {
            $shad.css({display: "none", opacity: ""}).data("opened_lb", 0);
        });
        $modbox.css({display: "none"});
    }
}

function verif_portable(elementID, fieldname) {
    return verif_telephone(elementID, fieldname, true);
}

function verif_telephone(elementID, fieldname, is_mobile) {
    var objElementHidden = document.getElementById(elementID + "Hidden");
    var objElement = document.getElementById(elementID);
    var erreurText = document.getElementById("erreur_msg");

    if (objElementHidden !== null) {
        var value = $(objElement).intlTelInput("getNumber");
        var type = $(objElement).intlTelInput("getNumberType");

        if (value.length == 12 && value.substr(1, 3) == "337") {
            if (elementID === "clientTel") {
                $("#clientMobileHidden").val(value);
            } else if (elementID == "telephone") {
                $("#mobileHidden").val(value);
            } else if (elementID == "billtelephone") {
                $("#billmobileHidden").val(value);
            } else if (elementID == "candidatTel") {
                $("#candidatTelHidden").val(value);
            }
        } else {
            if (
                $(objElement).intlTelInput("isValidNumber") !== false &&
                (type === 0 || type === 2 || type === 3 || type === 6)
            ) {
                $(objElementHidden).val(value);
            } else if (
                $(objElement).intlTelInput("isValidNumber") !== false &&
                type === 1
            ) {
                if (elementID === "clientTel") {
                    $("#clientMobileHidden").val(value);
                } else if (elementID == "telephone") {
                    $("#mobileHidden").val(value);
                } else if (elementID == "billtelephone") {
                    $("#billmobileHidden").val(value);
                } else if (elementID == "candidatTel") {
                    $("#candidatTelHidden").val(value);
                }
            }
        }

        if ($(objElement).intlTelInput("isValidNumber") === false) {
            $(objElement).addClass("inputErr");

            return false;
        }

        $(objElement).removeClass("inputErr");

        return true;
    }

    if ($.trim($(objElement).val()).length > 0) {
        if (
            $(objElement).intlTelInput("isValidNumber") === false ||
            (is_mobile && $(objElement).intlTelInput("getNumberType") === 0) ||
            (is_mobile == false &&
                $(objElement).intlTelInput("getNumberType") === 1)
        ) {
            if (
                is_mobile &&
                $(objElement).intlTelInput("getNumberType") === 0
            ) {
                erreurText.innerHTML =
                    '<p class="title_toolltip">' +
                    ajax_file(
                        "ajax_sprintf.php?arg2=" + fieldname + "_mobile"
                    ) +
                    " :</p>" +
                    ajax_file(
                        "ajax_sprintf.php?arg1=js_error_mobile&arg2=" +
                            fieldname
                    );
            } else {
                erreurText.innerHTML =
                    '<p class="title_toolltip">' +
                    ajax_file("ajax_sprintf.php?arg2=" + fieldname) +
                    " :</p>" +
                    ajax_file(
                        "ajax_sprintf.php?arg1=js_error_phone&arg2=" + fieldname
                    );
            }

            return false;
        } else {
            $(objElementHidden).val($(objElement).intlTelInput("getNumber"));
        }

        return true;
    }

    $(objElement).addClass("inputErr");

    return false;
}

// Page Rayon
function filterTrigger(event) {
    if ($('#filter_sticky').length) {
        var trigger = $('#filter_sticky');
        var filter = $('#trigger_filtre');
        var shad = $('#shad_link');
        var header = $('#site_head_wrap');

        if (!trigger.hasClass('triggered')) {
            $(event.target).addClass("is_checked");
            if ($('#filter_sticky .filters_container').length) {
                setTimeout(function () {
                    $('#filter_sticky .filters_container_wrapper').overlayScrollbars({});
                }, 350);
            }
            trigger.addClass('triggered');
            filter.addClass('show');
            header.addClass('filters_in');
            shad.addClass('actif filterOn');

            var wichFilter = $(event.target).attr("id");
            if ($("."+wichFilter).length) {
                $( ".filters_dropdown_bloc input[type='checkbox']" ).each(function( index ) {
                    $(this).prop( "checked", false );
                });

                $("."+wichFilter).prop('checked', true);
            }

            var wichFilter = $(event.target).attr("id");
            if ($("."+wichFilter).length) {
                $( ".filters_dropdown_bloc input[type='checkbox']" ).each(function( index ) {
                    $(this).prop( "checked", false );
                });

                $("."+wichFilter).prop('checked', true);
            }

        } else if (trigger.hasClass('triggered')) {
            $( ".filters_dropdown_content input[type='checkbox']" ).each(function( index ) {
                $(this).prop( "checked", false );
            });
            $( ".filtre_elem" ).each(function( index ) {
                $(this).removeClass( "is_checked" );
            });
            $(event.target).addClass("is_checked");
            closeFiltre();
        }

        if (trigger.hasClass('triggered')) {
            var shad_filtre = $('#shad_link.filterOn');
            shad_filtre.on("click touch", function(){
                closeFiltre();
            });
        }
    }
}

function filterTriggerIn(event) {
    // class added on input when user filters
    $(event.target).toggleClass("is_checked");

}

function filterWriteLabel(event) {
    var wichFilter = $(event.target).text();
    $("#filter_word").text("");
    $("#filter_word").text(wichFilter);
}

function closeFiltre(){
    $('#filter_sticky').removeClass('triggered');
    $('#trigger_filtre').removeClass('show');
    $('#site_head_wrap').removeClass('filters_in');
    $('#shad_link').removeClass('actif filterOn');
    $( ".filtre_elem" ).each(function( index ) {
        $(this).removeClass("is_checked");
    });
}

function getValsFilterPriceRayRange(){
    var parent = this.parentNode;
    var slides = parent.getElementsByTagName("input");
    var slide1 = parseFloat( slides[0].value );
    var slide2 = parseFloat( slides[1].value );
    if ( slide1 > slide2 ){ var tmp = slide2; slide2 = slide1; slide1 = tmp; }
    $("span.rangeValuesMin").text(slide1 + "€");
    $("span.rangeValuesMax").text(slide2 + "€");
}

$(window).on( "load", function() {
    // Initialize Sliders
    var sliderSections = document.getElementsByClassName("range-slider");
    for (var x = 0; x < sliderSections.length; x++) {
        var sliders = sliderSections[x].getElementsByTagName("input");
        for (var y = 0; y < sliders.length; y++) {
            if (sliders[y].type ==="range") {
                sliders[y].oninput = getValsFilterPriceRayRange;
                sliders[y].oninput();
            }
        }
    }
});

/**
 * Retrieves the wishlist products from the DOM and sends an AJAX request to retrieve additional information.
 *
 * @returns {void}
 */
function getWishlistProducts() {
    let array_elements = document.querySelectorAll('a[data-productid]');
    let array_ids = [];
    if (typeof array_elements != 'undefined' && array_elements.length > 0) {
        for (el of array_elements) {
            var id = el.getAttribute('data-productid');
            if (id != '' && id != 'undefined') {
                array_ids.push(id);
            }
        }
        let data = JSON.parse((JSON.stringify(Object.assign({}, array_ids))));
        $.ajax({
            type: 'get',
            url: path_relative_root + create_link("get_user_all_wishlist"),
            data: data,
            success: function (response) {
                if (response) {
                    if (typeof response != 'undefined') {
                        let array_product_id;

                        try {
                            array_product_id = JSON.parse(response);
                        } catch (e) {
                            return;
                        }

                        for (product_wishlist in array_product_id) {
                            $('a[data-productid="' + array_product_id[product_wishlist].fk_produit_id + '"], ' +
                              'button[data-productid="' + array_product_id[product_wishlist].fk_produit_id + '"]')
                                .addClass("existToWishlistButton")
                                .attr('data-wishlistproductid', array_product_id[product_wishlist].wishlist_product_id);
                        }
                    }
                } else {
                    return;
                }
            }
        });
    }
}

function showpdv(is_find_store) {
    $('.btnFindRetailer').addClass('loading');
    var shad, modbox, contents;
    $('html, body').animate({
        scrollTop: 0
    }, 500);

    $.ajax({
        type: 'post',
        url: path_relative_root + create_link('ajax_search_shop'),
        success: function (res) {
            if (res) {
                $('.btnFindRetailer').removeClass('loading');
                shad = document.getElementById('shad');
                modbox = document.getElementById('pdvBox');

                contents = $('<div />').html(res);
                $('#pdvBox').removeClass('deployed');

                // Make sure modbox will show on top of shad
                $(shad).after(modbox);

                // Inject store locator into modbox
                $('.store_locator', modbox).html($('.storeloc_form', contents).add($('.liste_distributeur_wrapper', contents)));

                var listeMag = document.getElementById('list-store');
                listeMag.innerHTML = '';

                //wording
                if (is_find_store) {
                    //Ajout-suppression de classe sur le conteneur pour différencier les css entre : le trouver en magasin/Choisir magasin préféré
                    $('#pdvBox').addClass('find_art_in_store');
                    $('#pdvBox').removeClass('choose_fav_mag');
                } else {
                    $('#pdvBox').addClass('choose_fav_mag');
                    $('#pdvBox').removeClass('find_art_in_store');
                }

                // On va rajouter le filtre pour n'avoir que les magasin avec le comptoir pour les PDV
                // On doit le rajouter en JS car on utilise la même vue avec la recherche magasin
                if (!document.getElementById('filter_pdv')) {
                    var caratactestiques = [];

                    if (document.getElementById('produit_id')) {
                        var productId = document.getElementById('produit_id').value;
                    }
                    if (document.getElementById('produit_caracterstiques')) {
                        var is_caracteristique = document.getElementById('produit_caracterstiques');
                    }
                }

                if (typeof MapsProviderService === 'undefined' || MapsProviderService.provider.name == 'googlemaps') {
                    initialize(true);
                } else if (typeof MapsProviderService != 'undefined') {
                    MapsProviderService.selectors = {
                        countryCodeSelector: '#search_pays',
                        countryCodeAttribute: 'data-code',
                        localityInputSelector: '#search_cp',
                        localityInputId: 'search_cp',
                        storeLocationFormSelector: '.storeloc_form',
                        geolocationButtonSelector: '.ou + .send_form',
                        storeListSelector: "#liste_distributeur",
                        scrollContentSelector: "#liste_distributeur_wrapper",
                        loaderSelector: '.img-loader-container',
                        storeListItemSelector: '.elem_liste_distributeur',
                        storeListItemTemplateSelector: '#store-container',
                        storeListItemClass: 'elem_liste_distributeur',
                        latAttribute: 'data-lat',
                        lngAttribute: 'data-lng',
                        addFavoriteSelector: '.addfavorite',
                        clientFavoriteStoreId: '#client_favorite_store_id',
                    };
                    MapsProviderService.initSearchShopPage();
                    MapsProviderService.updateList();
                }

                $(modbox).addClass('actif');
                $(shad).addClass('actif');
            } else {
                $('.btnFindRetailer').removeClass('loading');
            }
        }
    });
}

function closepdv() {
    var shad = document.getElementById('shad');
    var modbox = document.getElementById('pdvBox');

    if ($(".helloCustomer:visible").length) {
        $(modbox).removeClass('actif');
        $(shad).removeClass('actif');
        location.reload();
    } else {
        $(modbox).removeClass('actif');
        $(shad).removeClass('actif');
    }
}

$('body').on('mouseenter touchstart','#nrc_comments',function(){
    if ($(".swiperNetreviews.swiper-container .swiper-slide").length) {
        size_list = new Swiper(".swiperNetreviews.swiper-container", {
            loop: false,
            slidesPerView: 2,
            spaceBetween: 10,
            navigation: {
                nextEl: '.nextSlideFp',
                prevEl: '.prevSlideFp',
            },
        });
    }
});

if ($("#nrc_comments").length) {
    size_list = new Swiper(".swiperNetreviews", {
        loop: false,
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
            nextEl: '.netreviews-button-next',
            prevEl: '.netreviews-button-prev',
        },
    });
}

$(document).ready(function() {
    swiperBandeauCat();
} );

$(window).on("resize", function () {
    swiperBandeauCat();
});

function swiperBandeauCat() {
    var container = $('.selected_options.swiper-container');
    var swiperWrapper = $('.bandeau_menu_filter.swiper-wrapper');

    if ( swiperWrapper.width() > container.width() ) {
        // If images overflow the container, initialize Swiper
        new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
        });
    }
}

function createLineWoosmap(store, MapsProviderService){
    let div = '';
    let storeDetailsUrl = 'store_details.php?id=' + store.properties.store_id;
    let zipcodeAndCity = '';
    if (zipcode = store.properties.address.zipcode) {
        zipcodeAndCity = zipcode;
    }
    if (city = store.properties.address.city) {
        zipcodeAndCity += ' ' + this.formatAddress(city);
    }
    zipcodeAndCity = zipcodeAndCity.trim();
    if (MapsProviderService.device != null && MapsProviderService.device == 'mobile') {
        div = `<div class="bloc_marker_info">
                <p style="font-size:12px">
                    <span class="marker_store_name">${store.properties.name}</span>
                    <span class="marker_store_adr">${store.properties.address.lines.join('<br>')}</span>
                    <span class="marker_store_cp">${zipcodeAndCity}</span>
                </p>
                <div class="cta_marker_info">
                    <span class="learn_more"><a href="${storeDetailsUrl}">${Translator.translate('learn_more')}</a></span>
                    <a class="marker_go_map" href="">${Translator.translate('go_to_store')}</a>
            </div>`;
    } else {
        div = `<div class="info_popup">
                <div class="name"><a onclick="createDataLayer(${store.properties.store_id})" href="${storeDetailsUrl}">${store.properties.name}</a></div>
                <div class="adresse">${formatAddress(store.properties.address.lines.join('<br>'))}`;
        if (zipcodeAndCity.length > 0) {
            div += `<br>${zipcodeAndCity}`;
        }
        if (store.properties.address.country_code) {
            let countryTranslationKey = `pays_${store.properties.address.country_code.toLowerCase()}`;
            div += `, ${Translator.translate(countryTranslationKey)}`;
        }

        if (store.properties.contact.phone) {
            div += `<br><a href="tel:${store.properties.contact.phone}">${store.properties.contact.phone}</a>`;
        }
        div += `</div>`;

        if (store.properties.opening_hours) {
            div += `<div class="horaire_info">`;

            // map the weekly opening hours to display them in the popup
            Object.entries(store.properties.weekly_opening).forEach(([dayOfWeek, hours]) => {
                if (typeof hours !== 'object') {
                    return;
                }
                let dayName = Translator.translate(`day_0${dayOfWeek}`);
                let isCurrentDay = new Date().getDay() == dayOfWeek;
                if (hours.hours.length == 0) {
                    div += `<span class="day_time ${isCurrentDay ? 'currently_open' : ''}">
                                <span class="day">${dayName} </span><span class="time">${Translator.translate('closed')}</span>
                            </span><br>`;
                    return;
                } else {
                    let dayHours = hours.hours.map(hour => `${hour.start} - ${hour.end}`).join(" " + Translator.translate('and_txt') + " ");
                    div += `<span class="day_time ${isCurrentDay ? 'currently_open' : ''}">
                        <span class="day">${dayName} </span><span class="time">${dayHours}</span>
                    </span><br>`;
                }
            });
            div += `</div>`;
        }

        div += `<a class="savoir_plus" onclick="createDataLayer(${store.properties.store_id})" href="${storeDetailsUrl}">${Translator.translate('popup_shop_info')}</a>
        </div>`;
    }

    return div;
}
function formatAddress (address) {
    return address.charAt(0).toUpperCase() + address.slice(1).toLowerCase();
}

function elemGlobalShow() {
    $(".elem_global.delivery").show();
}

/***** PROD ASSOCS DATA LAYERS *****/

function dataLayer_associated_product() {
    var product_id = this.getAttribute('data-produit-id') ? event.currentTarget.getAttribute('data-produit-id') : '';
    if (typeof dataLayer_v3 !== 'undefined' && dataLayer_v3) {
        const isInSlider = $(this).closest('#gondole_complete').length > 0;
        const impressions = isInSlider ? dl_v3_impressions_look : dl_v3_impressions_like;
        const actionFields = isInSlider ? dlv3_action_fields_look : dlv3_action_fields_like;
        DataLayerTrigger.selectItem(impressions, actionFields, product_id);
    }
}

$(document).ready(function () {
    initDailymotionVideos();
});

function mySubmit(pType) {
    $(".cartLoader").addClass("loading");
    var form = document.getElementById("formPanier");

    form.action = create_link("order_basket");

    setTimeout(function () {
        form.submit();
    }, 250);
}

function custom_bancontact_hipay() {
    $('.inputBANCONTACT').on('click', function () {

        $(this).addClass('loading');
    });
}

/**
 * Updates the displayed color name in the UI when a label (or its parent) is hovered.
 *
 * This function extracts the color name from the hovered label's `data-nom` attribute,
 * its `title` attribute, or from a related input's `data-nom` attribute. If a color name
 * is found and the relevant UI element exists, it updates the text of `.chosen_color`
 * inside `#ligne_couleur .user_product_choice`.
 *
 * @param {Event} event - The event object triggered by hovering over a label or its child.
 */
function injectHoverColor(event) {
    if (!event) return;

    var label = $(event.currentTarget || event.target);

    if (!label.is('label')) {
        label = label.closest('label');
    }

    if (label.length && label.is('label')) {
        var colorName = label.attr('data-nom') || label.attr('title') || label.closest('.form_itm').find('input[type="radio"]').attr('data-nom');
        if (colorName && $('#ligne_couleur .user_product_choice').length) {
            $('#ligne_couleur .chosen_color').text(colorName);
        }
    }
}

/**
 * Updates the displayed chosen color name in the UI based on the user's selection.
 *
 * This function searches for the selected color input (radio button) within the element
 * with ID 'ligne_couleur'. If a checked input is found, it retrieves its color name from
 * the 'data-nom' attribute and updates the text of the element with class 'chosen_color'.
 * If no checked input is found, it falls back to searching for a div with classes
 * 'form_itm color checked', and attempts to retrieve the color name from its label's
 * 'data-nom' or 'title' attribute, or from the input's 'data-nom' attribute.
 *
 * @param {Event} event - The event object that triggered the function (optional).
 */
function injectChosenColor(event) {
    // Trouve la couleur sélectionnée (checked) dans le formulaire
    var checkedInput = $('#ligne_couleur input[name="itm_color"]:checked');
    if (checkedInput.length) {
        var colorName = checkedInput.attr('data-nom');
        if (colorName && $('#ligne_couleur .user_product_choice').length) {
            $('#ligne_couleur .chosen_color').text(colorName);
        }
    } else {
        var checkedDiv = $('#ligne_couleur .form_itm.color.checked');
        if (checkedDiv.length) {
            var label = checkedDiv.find('label');
            if (label.length) {
                var colorName = label.attr('data-nom') || label.attr('title') || checkedDiv.find('input[type="radio"]').attr('data-nom');
                if (colorName && $('#ligne_couleur .user_product_choice').length) {
                    $('#ligne_couleur .chosen_color').text(colorName);
                }
            }
        }
    }
}

// Initialize the color selection on page load
$(document).ready(function() {
    function updateChosenColor() {
        var checkedColor = $('#ligne_couleur input[name="itm_color"]:checked');
        if (checkedColor.length) {
            var colorName = checkedColor.attr('data-nom');
            if (colorName && $('#ligne_couleur .user_product_choice').length) {
                $('#ligne_couleur .chosen_color').text(colorName);
            }
        }
    }

    // Initialize the chosen color on page load
    updateChosenColor();

    // Update the chosen color when the color changes (event delegation)
    $(document).on('change', '#ligne_couleur input[name="itm_color"]', function() {
        var colorName = $(this).attr('data-nom');
        if (colorName && $('#ligne_couleur .user_product_choice').length) {
            $('#ligne_couleur .chosen_color').text(colorName);
        }
    });

    // Handle the hover with jQuery event delegation (more reliable than inline events)
    $(document).on('mouseenter', '#ligne_couleur .form_itm.color label', function(e) {
        var label = $(this);
        var colorName = label.attr('data-nom') || label.attr('title') || label.closest('.form_itm').find('input[type="radio"]').attr('data-nom');
        if (colorName && $('#ligne_couleur .user_product_choice').length) {
            $('#ligne_couleur .chosen_color').text(colorName);
        }
    });

    $(document).on('mouseleave', '#ligne_couleur .form_itm.color label', function(e) {
        injectChosenColor();
    });

    // Also handle the hover on the parent div in case
    $(document).on('mouseenter', '#ligne_couleur .form_itm.color', function(e) {
        // Only process if it's not already the label that triggered the event
        if (!$(e.target).is('label')) {
            var label = $(this).find('label');
            if (label.length) {
                var colorName = label.attr('data-nom') || label.attr('title') || $(this).find('input[type="radio"]').attr('data-nom');
                if (colorName && $('#ligne_couleur .user_product_choice').length) {
                    $('#ligne_couleur .chosen_color').text(colorName);
                }
            }
        }
    });

    $(document).on('mouseleave', '#ligne_couleur .form_itm.color', function(e) {
        injectChosenColor();
    });
});

/**
 * Updates the product quantity input and manages the enabled/disabled state of
 * the plus and minus quantity selectors based on the current quantity and stock.
 *
 * @param {string} action - The action to perform: 'plus' to increment or 'minus' to decrement the quantity.
 *
 * The function:
 * - Increments or decrements the selected product quantity based on the action.
 * - Ensures the quantity does not exceed available stock or go below 1.
 * - Updates the input field with the new quantity.
 * - Adds or removes the 'selector_disabled' class on the plus/minus selectors as appropriate.
 */
function updateProductQuantity(action) {

    var qte_stock,
        qte_input,
        plus_selector,
        minus_selector;

    // Recover html selectors
    plus_selector = $("#liste_qte .qte_plus");
    minus_selector = $("#liste_qte .qte_minus");

    // Get product stock quantity and input quantity selected values
    qte_stock = $('#product_stock_counter').val();
    qte_stock = (qte_stock != '') ? parseInt(qte_stock, 10) : 0;
    qte_input = $('#qteProd').val();
    qte_input = (qte_input != '' && !isNaN(qte_input)) ? parseInt(qte_input, 10) : 1;

    if (action == 'plus') {
        qte_input++;

        // Update form
        if (qte_input < qte_stock) {
            $('#qteProd').val(qte_input);
        } else if (qte_input == qte_stock) {
            $('#qteProd').val(qte_input);
            plus_selector.addClass('selector_disabled');
        } else {
            qte_input--;
            plus_selector.addClass('selector_disabled')
        }

        // Remove disabled classes if necessary
        if ((qte_input > 1) && (minus_selector.hasClass('selector_disabled'))) {
            minus_selector.removeClass('selector_disabled');
        }

    } else if (action == 'minus') {
        qte_input--;
        // If qte stored in input can be decremented
        if ((qte_input > 1) || (qte_input == 1)) {
            $('#qteProd').val(qte_input);
            plus_selector.removeClass('selector_disabled')
        }

        // add disabled class if needed
        if (qte_input == 1) {
            if (!minus_selector.hasClass('selector_disabled')) {
                minus_selector.addClass('selector_disabled');
            }
        }
    }
}

// Back to Top functionality
var backToTop = function () {
    var scrollTrigger = 100;
    var scrollTop = $(window).scrollTop();

    if (scrollTop > scrollTrigger) {
        $(".backToTop").addClass("show");
    } else {
        $(".backToTop").removeClass("show");
    }
};

backToTop();

$(window).on("scroll", function () {
    backToTop();
});

$(".backToTop").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
        {
            scrollTop: 0,
        },
        700
    );
});

function setStoreContactOptinDefault() {
    var optinNo = $('#content_pdvBox_new #optin_n');

    if (optinNo.length) {
        optinNo.prop('checked', true);
    }
}

function setStockAlertOptinDefault() {
    var optinNo = $('#content_alerte_stock_nl #optin_n');

    if (optinNo.length) {
        optinNo.prop('checked', true);
    }
}


var storeContactOptinInitialized = false;
var originalContactFormHtml = null;
var stockAlertOptinInitialized = false;

/**
 * Display lightbox contact store
 */
function showLightboxContactStore() {
    var shad = document.getElementById('shad');
    var modbox = document.getElementById('pdvBox');

    $('html, body').animate({
        scrollTop: 0
    }, 500);

    $(modbox).addClass('actif');
    $(shad).addClass('actif');
    $(shad).on('click', closeLightboxContactStore);
    $('#content_pdvBox').show();
    $(shad).addClass('below_header');

    if (!storeContactOptinInitialized) {
        setStoreContactOptinDefault();
        storeContactOptinInitialized = true;
    }

    setTimeout(function () {
        var phoneField = $('#numTelephone');

        phoneField.intlTelInput();

        // Prevent desktop auto-focus side effects from intlTelInput init in this lightbox.
        if (document.activeElement === phoneField.get(0)) {
            phoneField.trigger('blur');
        }
    }, 400);

    const numTel = document.querySelector('#numTelephone');
    const placeholder = numTel.closest('label').querySelector('.placeholderTxt');

    function majPlaceholder() {
        if (numTel.value.trim() === '') {
            placeholder.classList.remove('inUse');
            numTel.classList.remove('inUse');
        } else {
            placeholder.classList.add('inUse');
            numTel.classList.add('inUse');
        }
    }

    numTel.addEventListener('input', majPlaceholder);
    numTel.addEventListener('blur', majPlaceholder);
    majPlaceholder();
}

/**
 * Close lightbox contact store
 */
function closeLightboxContactStore() {
    var shad = document.getElementById('shad');
    var modbox = document.getElementById('pdvBox');

    $(modbox).removeClass('actif');
    $(shad).removeClass('actif');
    $(shad).removeClass('below_header');

    if ($('#pdvBox').hasClass('thanks') && originalContactFormHtml !== null) {
        $('#content_pdvBox_new').html(originalContactFormHtml);
        $('#pdvBox').removeClass('thanks');
        storeContactOptinInitialized = false;
        originalContactFormHtml = null;
    }
}

/**
 * Send request contact to store
 */
function sendFormContactByStore(formulaire) {
    var $form = $(formulaire);
    var isValid = true;

    if (!validateContactStoreName($form.find('#clientPrenom'))) {
        isValid = false;
    }

    if (!validateContactStoreName($form.find('#clientNom'))) {
        isValid = false;
    }

    if (!validateContactStoreEmail($form.find('#clientMail'))) {
        isValid = false;
    }

    if (!validateContactStoreTel($form.find('#numTelephone'))) {
        isValid = false;
    }

    if (!validateContactStoreCompulsory($form.find('#clientMessage'))) {
        isValid = false;
    }

    if (!isValid) {
        return false;
    }

    var optin_g = ($("input[name='optin']:checked").val());
    var optin_sms = ($("input[name='optin_sms']:checked").val());
    var optin_partners = ($("input[name='optin_partners']:checked").val());

    var data = {
        'produit_id': formulaire.produit_id.value,
        'produit_url': formulaire.produit_url.value,
        'client_nom': formulaire.nom.value,
        'client_prenom': formulaire.prenom.value,
        'client_email': formulaire.email.value,
        'client_telephone': formulaire.tel.value,
        'client_message': formulaire.message.value,
        'magasin_id': formulaire.magasin_id.value,
        'optin_general': optin_g,
        'optin_sms': optin_sms,
        'optin_partners': optin_partners
    };

    originalContactFormHtml = $('#content_pdvBox_new').html();

    $.ajax({
        url: path_relative_root + create_link('ajax_contactbystore'),
        type: 'post',
        data: data,
        async: false,
        success: function (res) {
            try {
                $('#content_pdvBox_new').html(JSON.parse(res));
                $('#pdvBox').addClass('thanks');
            } catch (e) {
            }
        }
    });
    return false; //prevent submit
}

/**
 * Display lightbox Newsletter registration
 */
function showNewsletterRegistrationLightbox(email, is_optin) {

    var shad = document.getElementById('shad');
    var modbox = document.getElementById('lightbox_alerte_stock');

    $(modbox).addClass('actif');
    $(shad).addClass('actif');
    $(shad).on('click', closeNewsletterRegistrationLightbox);
    $('#content_alerte_stock_nl').show();

    // set value mail in input hidden
    $('#newsletter_email').val(email);
    $("#content_alerte_stock_nl .input_container.bar_top").show();
    $( "#error_newsletter" ).hide();
    $( "#error_email" ).hide();
    if (is_optin != "1" && !stockAlertOptinInitialized) {
        setStockAlertOptinDefault();
        stockAlertOptinInitialized = true;
    }
    if (is_optin == "1") {
        $("#content_alerte_stock_nl .btn_newsletter_subscription_confirmation").hide();
        $("#content_alerte_stock_nl .close_popup").show();
        $("#content_alerte_stock_nl .container_optin_offre").hide();
    } else {
        $("#content_alerte_stock_nl .btn_container").show();
        $("#content_alerte_stock_nl .btn_newsletter_subscription_confirmation").show();
        $("#content_alerte_stock_nl .close_popup").hide();
        $("#content_alerte_stock_nl .container_optin_offre").show();
    }
}

/**
 * Sumit form newsletter
 **/
function submitFormNewsletter() {
    var optin = $("#wrapper_optin input[name='optin']:checked").val();

    if (typeof optin !== "undefined") {
        if (optin == 1) {
            $.ajax({
                url: path_relative_root + create_link('ajax_newsletter_email'),
                type: 'post',
                data: {
                    email: $('#newsletter_email').val()
                },
                cache: false,
                success: function (res) {
                    var resultat = JSON.parse(res);
                    if (resultat.valid == false) {
                        $( '#error_email' ).addClass( 'valid' );
                        $( '#error_email' ).css('display', 'block' );
                        $('.input_container.bar_top').css('display', 'none');
                        $('.btn_container').css('display', 'none');
                        $('.close_popup').css('display', 'block');
                    } else {
                        $('#error_newsletter').removeClass('error');
                        $('#error_newsletter').addClass('valid');
                        $('#error_newsletter').html(translate(resultat.message));
                        $('.input_container.bar_top').css('display', 'none');
                        $('.btn_container').css('display', 'none');
                        $('.close_popup').css('display', 'block');
                        $('#error_newsletter').css('display', 'block');
                    }
                }
            });
        } else {
            closeNewsletterRegistrationLightbox();
        }
    } else {
        $( '.w-radio-group' ).addClass( 'w-has-error' );
    }
    return false;
}

/**
 * Close lightbox Newsletter registration
 */
function closeNewsletterRegistrationLightbox() {
    var shad = document.getElementById('shad');
    var modbox = document.getElementById('lightbox_alerte_stock');

    $(modbox).removeClass('actif');
    $(shad).removeClass('actif');
    $( '.w-radio-group' ).removeClass( 'w-has-error' );
}
//Push associated product info into datalayer
function triggerDataLayer(evt) {
    if (window.$('.swiperTg')) {
        var product_id = evt.getAttribute('data-prod') || '';
        if (product_id) {;
            handleDataLayer(product_id);
        }
    }
}


/**
 * Handle the "add to cart" action triggered by the JOIN Stories widget.
 * Doc: https://docs.join-stories.com/docs/add-to-cart-javascript
 *
 * When a user clicks "Add to cart" inside a story, JOIN emits the
 * JOIN_STORIES_ADD_TO_CART event with product data (offerId / variantOfferId).
 *
 * This listener:
 * - Extracts the relevant product identifier from the event
 * - Maps it to the site's expected format (refColorSize)
 * - Calls the internal AJAX endpoint to add the product to the cart
 * - Parses the response and determines success or failure
 * - Notifies JOIN of the result via JoinStories.resolveAddToCart()
 *
 * It also handles error cases such as missing IDs, invalid responses,
 * and out-of-stock situations.
 *
 * Additionally, the JOIN_STORIES_SEE_CART event redirects the user
 * to the cart page when triggered from the widget.
 */
document.addEventListener('JOIN_STORIES_ADD_TO_CART', function (event) {
    var detail = event.detail || {};

    var orderId = detail.orderId;
    var produitReference = detail.offerId;
    var gtin = detail.productId || null;
    var quantity = detail.quantity || 1;

    if (!orderId) {
        console.error('orderId manquant');
        return;
    }

    // Build AJAX data: prefer GTIN (unique EAN/gencode) when available,
    // otherwise fall back to refColorSize (variantOfferId / offerId)
    var ajaxData = {
        qte: quantity,
        dataTypeReturn: 'json'
    };

    if (gtin) {
        ajaxData.gtin = gtin;
    } else {
        var siteProductId = produitReference || null;

        if (!siteProductId) {
            console.error('[JOIN] No usable product identifier', detail);
            if (window.JoinStories && typeof window.JoinStories.resolveAddToCart === 'function') {
                window.JoinStories.resolveAddToCart(orderId, true);
            }
            return;
        }

        ajaxData.refColorSize = siteProductId;
    }

    $.ajax({
        url: path_relative_root + 'ajax_upd_panier.php',
        type: 'get',
        dataType: 'text',
        data: ajaxData,
        success: function (response) {
            var payload = null;

            try {
                payload = (typeof response === 'string') ? JSON.parse(response) : response;
            } catch (e) {
                console.error('[JOIN] Non-JSON cart response', response);
                window.JoinStories?.resolveAddToCart(orderId, true);
                return;
            }

            var success = payload && Number(payload.error) === 0;
            var isOutOfStock = false;

            if (!success && payload && payload.error && payload.error.msg) {
                var msg = String(payload.error.msg).toLowerCase();
                isOutOfStock =
                    msg.indexOf('rupture') !== -1 ||
                    msg.indexOf('stock') !== -1;
            }

            var response_basket = ajax_file(path_relative_root + 'ajax_show_basket.php');
            if (response_basket) {
                $('#cart_top').html(response_basket);
            }

            if (window.JoinStories && typeof window.JoinStories.resolveAddToCart === 'function') {
                if (isOutOfStock) {
                    window.JoinStories.resolveAddToCart(orderId, 'PRODUCT_OUT_OF_STOCK');
                } else if (success) {
                    window.JoinStories.resolveAddToCart(orderId);
                } else {
                    window.JoinStories.resolveAddToCart(orderId, true);
                }
            }
        },
        error: function (xhr, status, error) {
            console.error('[JOIN] ajax_upd_panier failed', status, error);

            if (window.JoinStories && typeof window.JoinStories.resolveAddToCart === 'function') {
                window.JoinStories.resolveAddToCart(orderId, true);
            }
        }
    });
});

document.addEventListener('JOIN_STORIES_SEE_CART', function () {
    window.location.href = path_relative_root + 'panier.php';
});

function loadScriptOnce(alias) {
    var scriptId = 'join-widget-script-' + alias;

    if (document.getElementById(scriptId)) {
        return;
    }

    var script = document.createElement('script');
    script.id = scriptId;
    script.setAttribute('data-join-widget-alias', alias);
    script.setAttribute('data-join-widget-id', 'join-widget-' + alias);
    script.src = 'https://5five.my.join-stories.com/widgets/' + alias + '/index.js';
    script.type = 'text/javascript';
    script.async = true;

    document.body.appendChild(script);
}

function initJoinWidgets() {
    var widgets = document.querySelectorAll('.join-inline-widget');

    widgets.forEach(function (placeholder, index) {
        if (placeholder.dataset.joinInitialized === '1') {
            return;
        }

        var alias = placeholder.id.split('join-widget-')[1];

        if (!alias) {
            console.error('[JOIN] Missing data-join-alias', placeholder);
            return;
        }

        placeholder.dataset.joinInitialized = '1';

        loadScriptOnce(alias);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initJoinWidgets();
});

//based on product id and datalayer impressions push selected product info into datalayer
function handleDataLayer(product_id) {

    var hasDLv3 = typeof dataLayer_v3 !== 'undefined' && dataLayer_v3;
    var hasLike = typeof dl_v3_impressions_like !== 'undefined' && dl_v3_impressions_like;
    var hasLook = typeof dl_v3_impressions_look !== 'undefined' && dl_v3_impressions_look;
    var hasMain = typeof dl_v3_impressions      !== 'undefined' && dl_v3_impressions;
    var hasActions = typeof dlv3_action_fields  !== 'undefined' && dlv3_action_fields;
    var hasActionsLike = typeof dlv3_action_fields_like  !== 'undefined' && dlv3_action_fields_like;
    var hasActionsLook = typeof dlv3_action_fields_look  !== 'undefined' && dlv3_action_fields_look;


    if (!hasDLv3) {
        return;
    }
    const isInSlider = $(this).closest('#assoc_rayon_slider').length > 0;
    let impressions = isInSlider ? (hasLike ? dl_v3_impressions_like : null) : (hasLook ? dl_v3_impressions_look : null);
    let actionFields = isInSlider ? (hasActionsLike ? dlv3_action_fields_like : null) : (hasActionsLook ? dlv3_action_fields_look : null);

    if (hasMain && hasActions) {
        impressions = dl_v3_impressions;
        actionFields = dlv3_action_fields;
    }
    if (impressions && actionFields) {
        DataLayerTrigger.selectItem(impressions, actionFields, product_id);
    }
}

// Join Stories: reveal container once the deferred widget script has been executed (window.load).
window.addEventListener('load', function () {
    document.querySelectorAll('.join-widget-target-component').forEach(function (el) {
        el.classList.add('is-loaded');
    });
});
